// @flow
/* eslint-disable no-use-before-define */
/**
 * みんなの契約書
 * API一覧
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI-Generator
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as url from "url";
import portableFetch from "../../libs/fetch"
import { Configuration } from "./configuration";

const BASE_PATH: string = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 */
export type FetchAPI = {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 */
export type FetchArgs = {
    url: string;
    options: {};
}

/**
 *
 * @export
 */
export type RequestOptions = {
    headers?: {};
    query?: {};
    body?: string | FormData;
}

/**
 * * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name:string = "RequiredError"
    constructor(field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 */
export type AiExtractContractFormValuesInput = {
    /**
     * データ
     * @type {string}
     * @memberof AiExtractContractFormValuesInput
     */
    data: string;
    /**
     * ファイル形式
     * @type {string}
     * @memberof AiExtractContractFormValuesInput
     */
    format: string;
}

/**
 * 
 * @export
 */
export type AiExtractContractFormValuesResponse = {
    /**
     * 回答
     * @type {Object}
     * @memberof AiExtractContractFormValuesResponse
     */
    response: Object;
}

/**
 * 
 * @export
 */
export type AllowedIp = {
    /**
     * ID
     * @type {number}
     * @memberof AllowedIp
     */
    id: number;
    /**
     * 許可IP
     * @type {string}
     * @memberof AllowedIp
     */
    range: string;
    /**
     * メモ
     * @type {string}
     * @memberof AllowedIp
     */
    memo?: string;
}

/**
 * 
 * @export
 */
export type AllowedIpInput = {
    /**
     * 許可IP
     * @type {string}
     * @memberof AllowedIpInput
     */
    ranges: string;
    /**
     * メモ
     * @type {string}
     * @memberof AllowedIpInput
     */
    memo?: string;
}

/**
 * 
 * @export
 */
export type Archive = {
    /**
     * ID
     * @type {number}
     * @memberof Archive
     */
    id: number;
    /**
     * ファイルID
     * @type {number}
     * @memberof Archive
     */
    fileId: number;
}

/**
 * 
 * @export
 */
export type BillingPortalSession = {
    /**
     * Stripe Billing Portal URL
     * @type {string}
     * @memberof BillingPortalSession
     */
    url: string;
}

/**
 * 
 * @export
 */
export type Clause = {
    /**
     * ID
     * @type {number}
     * @memberof Clause
     */
    id: number;
    /**
     * テンプレートID
     * @type {number}
     * @memberof Clause
     */
    templateId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof Clause
     */
    title?: string;
    /**
     * 本文
     * @type {string}
     * @memberof Clause
     */
    body?: string;
    /**
     * 共通条項のID
     * @type {number}
     * @memberof Clause
     */
    commonId?: number;
    /**
     * 順序
     * @type {number}
     * @memberof Clause
     */
    position: number;
}

/**
 * 
 * @export
 */
export type CommonClause = {
    /**
     * ID
     * @type {number}
     * @memberof CommonClause
     */
    id: number;
    /**
     * 名前
     * @type {string}
     * @memberof CommonClause
     */
    name: string;
    /**
     * タイトル
     * @type {string}
     * @memberof CommonClause
     */
    title: string;
    /**
     * 本文
     * @type {string}
     * @memberof CommonClause
     */
    body: string;
    /**
     * 
     * @type {User}
     * @memberof CommonClause
     */
    createdBy?: User;
    /**
     * 
     * @type {User}
     * @memberof CommonClause
     */
    updatedBy?: User;
}

/**
 * 
 * @export
 */
export type CommonClauseInput = {
    /**
     * 共通条項名
     * @type {string}
     * @memberof CommonClauseInput
     */
    name: string;
    /**
     * タイトル
     * @type {string}
     * @memberof CommonClauseInput
     */
    title: string;
    /**
     * 本文
     * @type {string}
     * @memberof CommonClauseInput
     */
    body: string;
    /**
     * 変数
     * @type {Array<CommonClauseVariableInput>}
     * @memberof CommonClauseInput
     */
    variables: Array<CommonClauseVariableInput>;
}

/**
 * 共通条項一覧
 * @export
 */
export type CommonClauseList = {
    /**
     * 全件数
     * @type {number}
     * @memberof CommonClauseList
     */
    total: number;
    /**
     * 共通条項一覧
     * @type {Array<CommonClauseListItem>}
     * @memberof CommonClauseList
     */
    items: Array<CommonClauseListItem>;
}

/**
 * 
 * @export
 */
export type CommonClauseListItem = {
    /**
     * 
     * @type {number}
     * @memberof CommonClauseListItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CommonClauseListItem
     */
    name: string;
}

/**
 * 
 * @export
 */
export type CommonClauseVariable = {
    /**
     * ID
     * @type {number}
     * @memberof CommonClauseVariable
     */
    id: number;
    /**
     * 共通条項ID
     * @type {number}
     * @memberof CommonClauseVariable
     */
    commonClauseId: number;
    /**
     * 変数ID
     * @type {number}
     * @memberof CommonClauseVariable
     */
    variableId: number;
    /**
     * テンプレート内での順序
     * @type {number}
     * @memberof CommonClauseVariable
     */
    position: number;
}

/**
 * 
 * @export
 */
export type CommonClauseVariableInput = {
    /**
     * ID(既存の場合)
     * @type {number}
     * @memberof CommonClauseVariableInput
     */
    id?: number;
    /**
     * 名前
     * @type {string}
     * @memberof CommonClauseVariableInput
     */
    name: string;
    /**
     * 種別
     * @type {string}
     * @memberof CommonClauseVariableInput
     */
    type: string;
    /**
     * 種別詳細
     * @type {string}
     * @memberof CommonClauseVariableInput
     */
    typeDetail: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof CommonClauseVariableInput
     */
    required: boolean;
    /**
     * 本文に含まれるかどうか
     * @type {boolean}
     * @memberof CommonClauseVariableInput
     */
    within: boolean;
    /**
     * 説明
     * @type {string}
     * @memberof CommonClauseVariableInput
     */
    description: string;
}

/**
 * 
 * @export
 */
export type Config = {
    /**
     * キー
     * @type {string}
     * @memberof Config
     */
    key: string;
    /**
     * 値
     * @type {Object}
     * @memberof Config
     */
    value: Object;
    /**
     * 編集可能かどうか
     * @type {boolean}
     * @memberof Config
     */
    editable: boolean;
}

/**
 * 
 * @export
 */
export type ConfigInput = {
    /**
     * キー
     * @type {string}
     * @memberof ConfigInput
     */
    key: string;
    /**
     * 値(JSON形式)
     * @type {string}
     * @memberof ConfigInput
     */
    value: string;
}

/**
 * 
 * @export
 */
export type ConfigPasswordPolicy = {
    /**
     * 最小文字数
     * @type {number}
     * @memberof ConfigPasswordPolicy
     */
    minLength: number;
    /**
     * 大文字を含めるかどうか
     * @type {boolean}
     * @memberof ConfigPasswordPolicy
     */
    requireUppercase: boolean;
    /**
     * 小文字を含めるかどうか
     * @type {boolean}
     * @memberof ConfigPasswordPolicy
     */
    requireLowercase: boolean;
    /**
     * 数字を含めるかどうか
     * @type {boolean}
     * @memberof ConfigPasswordPolicy
     */
    requireNumbers: boolean;
    /**
     * 記号を含めるかどうか
     * @type {boolean}
     * @memberof ConfigPasswordPolicy
     */
    requireSymbols: boolean;
}

/**
 * 
 * @export
 */
export type Contract = {
    /**
     * ID
     * @type {number}
     * @memberof Contract
     */
    id: number;
    /**
     * ファイルID
     * @type {number}
     * @memberof Contract
     */
    fileId: number;
    /**
     * プレビュー用PDFのファイルID
     * @type {number}
     * @memberof Contract
     */
    previewFileId: number;
    /**
     * 作成者のユーザーID
     * @type {number}
     * @memberof Contract
     */
    userId?: number;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof Contract
     */
    stampRequestId?: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof Contract
     */
    corporationId?: number;
    /**
     * 更新状態
     * @type {string}
     * @memberof Contract
     */
    renewalState?: string;
}

/**
 * 
 * @export
 */
export type ContractConfirmationRequestInput = {
    /**
     * 書類名
     * @type {string}
     * @memberof ContractConfirmationRequestInput
     */
    name: string;
    /**
     * 
     * @type {FileInput}
     * @memberof ContractConfirmationRequestInput
     */
    file?: FileInput;
    /**
     * フォーム回答
     * @type {Array<ContractParameterInput>}
     * @memberof ContractConfirmationRequestInput
     */
    parameters: Array<ContractParameterInput>;
}

/**
 * 
 * @export
 */
export type ContractConfirmationVariable = {
    /**
     * ID
     * @type {number}
     * @memberof ContractConfirmationVariable
     */
    id: number;
    /**
     * 変数ID
     * @type {number}
     * @memberof ContractConfirmationVariable
     */
    variableId: number;
    /**
     * 順序
     * @type {number}
     * @memberof ContractConfirmationVariable
     */
    position: number;
}

/**
 * 
 * @export
 */
export type ContractCreationRequestInput = {
    /**
     * テンプレートID
     * @type {number}
     * @memberof ContractCreationRequestInput
     */
    templateId: number;
    /**
     * 契約書名
     * @type {string}
     * @memberof ContractCreationRequestInput
     */
    name: string;
    /**
     * フォーム回答
     * @type {Array<ContractParameterInput>}
     * @memberof ContractCreationRequestInput
     */
    parameters: Array<ContractParameterInput>;
}

/**
 * 
 * @export
 */
export type ContractFileUpdate = {
    /**
     * 
     * @type {FileInput}
     * @memberof ContractFileUpdate
     */
    file: FileInput;
    /**
     * コメント
     * @type {string}
     * @memberof ContractFileUpdate
     */
    comment: string;
}

/**
 * 
 * @export
 */
export type ContractFormItem = {
    /**
     * ID
     * @type {number}
     * @memberof ContractFormItem
     */
    id: number;
    /**
     * 項目名
     * @type {string}
     * @memberof ContractFormItem
     */
    name: string;
    /**
     * 必須フラグ
     * @type {boolean}
     * @memberof ContractFormItem
     */
    required: boolean;
    /**
     * 項目タイプ
     * @type {string}
     * @memberof ContractFormItem
     */
    type: string;
    /**
     * タイプ詳細（JSON）
     * @type {Object}
     * @memberof ContractFormItem
     */
    typeDetail?: Object;
    /**
     * AI抽出フラグ
     * @type {boolean}
     * @memberof ContractFormItem
     */
    aiExtractionEnabled?: boolean;
    /**
     * AI抽出プロンプト
     * @type {string}
     * @memberof ContractFormItem
     */
    aiExtractionPrompt?: string;
    /**
     * 表示順序
     * @type {number}
     * @memberof ContractFormItem
     */
    position?: number;
    /**
     * 編集可能フラグ
     * @type {boolean}
     * @memberof ContractFormItem
     */
    editable: boolean;
    /**
     * 作成日時
     * @type {string}
     * @memberof ContractFormItem
     */
    createdAt?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof ContractFormItem
     */
    updatedAt?: string;
    /**
     * 削除日時
     * @type {string}
     * @memberof ContractFormItem
     */
    deletedAt?: string;
}

/**
 * 
 * @export
 */
export type ContractFormItemInput = {
    /**
     * 項目名
     * @type {string}
     * @memberof ContractFormItemInput
     */
    name: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof ContractFormItemInput
     */
    required: boolean;
    /**
     * 項目タイプ
     * @type {string}
     * @memberof ContractFormItemInput
     */
    type: string;
    /**
     * 項目タイプ詳細
     * @type {string}
     * @memberof ContractFormItemInput
     */
    typeDetail?: string;
    /**
     * AI抽出フラグ
     * @type {boolean}
     * @memberof ContractFormItemInput
     */
    aiExtractionEnabled?: boolean;
    /**
     * AI抽出プロンプト
     * @type {string}
     * @memberof ContractFormItemInput
     */
    aiExtractionPrompt?: string;
}

/**
 * 契約管理項目一覧
 * @export
 */
export type ContractFormItemList = {
    /**
     * 全件数
     * @type {number}
     * @memberof ContractFormItemList
     */
    total: number;
    /**
     * 契約管理項目一覧
     * @type {Array<ContractFormItem>}
     * @memberof ContractFormItemList
     */
    items: Array<ContractFormItem>;
}

/**
 * 
 * @export
 */
export type ContractFormItemPositionInput = {
    /**
     * 順序 <br />-1:上に移動 1:下に移動
     * @type {number}
     * @memberof ContractFormItemPositionInput
     */
    direction: number;
}

/**
 * 
 * @export
 */
export type ContractFormValue = {
    /**
     * ID
     * @type {number}
     * @memberof ContractFormValue
     */
    id: number;
    /**
     * 契約ID
     * @type {number}
     * @memberof ContractFormValue
     */
    contractId: number;
    /**
     * 項目ID
     * @type {number}
     * @memberof ContractFormValue
     */
    itemId: number;
    /**
     * 項目タイプ
     * @type {string}
     * @memberof ContractFormValue
     */
    type: string;
    /**
     * 項目値
     * @type {string}
     * @memberof ContractFormValue
     */
    value?: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof ContractFormValue
     */
    createdAt?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof ContractFormValue
     */
    updatedAt?: string;
    /**
     * 削除日時
     * @type {string}
     * @memberof ContractFormValue
     */
    deletedAt?: string;
}

/**
 * 
 * @export
 */
export type ContractFormValueInput = {
    /**
     * 項目ID
     * @type {number}
     * @memberof ContractFormValueInput
     */
    itemId: number;
    /**
     * 項目値
     * @type {string}
     * @memberof ContractFormValueInput
     */
    value: string;
    /**
     * 項目タイプ
     * @type {string}
     * @memberof ContractFormValueInput
     */
    type: string;
}

/**
 * 
 * @export
 */
export type ContractFormValueUpdate = {
    /**
     * 項目値
     * @type {string}
     * @memberof ContractFormValueUpdate
     */
    value: string;
    /**
     * 項目タイプ
     * @type {string}
     * @memberof ContractFormValueUpdate
     */
    type: string;
    /**
     * コメント
     * @type {string}
     * @memberof ContractFormValueUpdate
     */
    comment: string;
}

/**
 * 
 * @export
 */
export type ContractInput = {
    /**
     * 
     * @type {FileInput}
     * @memberof ContractInput
     */
    file?: FileInput;
    /**
     * 契約書情報
     * @type {Array<ContractFormValueInput>}
     * @memberof ContractInput
     */
    values: Array<ContractFormValueInput>;
}

/**
 * 
 * @export
 */
export type ContractLimit = {
    /**
     * 合計制限
     * @type {number}
     * @memberof ContractLimit
     */
    totalLimit: number;
    /**
     * 単体プランの制限
     * @type {number}
     * @memberof ContractLimit
     */
    basicLimit: number;
    /**
     * オプションプランの制限
     * @type {number}
     * @memberof ContractLimit
     */
    optionLimit: number;
    /**
     * 今月の契約数
     * @type {number}
     * @memberof ContractLimit
     */
    count: number;
    /**
     * 上限に達しているかどうか
     * @type {boolean}
     * @memberof ContractLimit
     */
    isExceeded: boolean;
}

/**
 * 契約一覧
 * @export
 */
export type ContractList = {
    /**
     * 全件数
     * @type {number}
     * @memberof ContractList
     */
    total: number;
    /**
     * 契約一覧
     * @type {Array<Contract>}
     * @memberof ContractList
     */
    items: Array<Contract>;
}

/**
 * 
 * @export
 */
export type ContractNotification = {
    /**
     * ID
     * @type {number}
     * @memberof ContractNotification
     */
    id: number;
    /**
     * 日数
     * @type {number}
     * @memberof ContractNotification
     */
    day: number;
    /**
     * 作成日時
     * @type {string}
     * @memberof ContractNotification
     */
    createdAt?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof ContractNotification
     */
    updatedAt?: string;
    /**
     * 削除日時
     * @type {string}
     * @memberof ContractNotification
     */
    deletedAt?: string;
}

/**
 * 
 * @export
 */
export type ContractNotificationInput = {
    /**
     * 通知日数
     * @type {Array<number>}
     * @memberof ContractNotificationInput
     */
    days: Array<number>;
}

/**
 * 
 * @export
 */
export type ContractParameterInput = {
    /**
     * 変数ID
     * @type {number}
     * @memberof ContractParameterInput
     */
    variableId: number;
    /**
     * 値
     * @type {string}
     * @memberof ContractParameterInput
     */
    value?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof ContractParameterInput
     */
    file?: FileInput;
}

/**
 * 
 * @export
 */
export type ContractRenewalStateInput = {
    /**
     * 継続状態(confirmed)
     * @type {string}
     * @memberof ContractRenewalStateInput
     */
    renewalState: string;
}

/**
 * 
 * @export
 */
export type ContractRequest = {
    /**
     * ID
     * @type {number}
     * @memberof ContractRequest
     */
    id: number;
    /**
     * 種別
     * @type {string}
     * @memberof ContractRequest
     */
    type: string;
    /**
     * ステータス
     * @type {string}
     * @memberof ContractRequest
     */
    state: string;
    /**
     * 名称
     * @type {string}
     * @memberof ContractRequest
     */
    name: string;
    /**
     * 
     * @type {Template}
     * @memberof ContractRequest
     */
    template?: Template;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof ContractRequest
     */
    stampRequestId?: number;
    /**
     * 
     * @type {User}
     * @memberof ContractRequest
     */
    creator?: User;
    /**
     * 保留中かどうか
     * @type {boolean}
     * @memberof ContractRequest
     */
    suspend?: boolean;
    /**
     * 保留にした日付
     * @type {string}
     * @memberof ContractRequest
     */
    suspendedAt?: string;
    /**
     * 収入印紙の負担者
     * @type {string}
     * @memberof ContractRequest
     */
    revenueStamp?: string;
    /**
     * 収入印紙の金額（単位：円）
     * @type {number}
     * @memberof ContractRequest
     */
    revenueStampAmount?: number;
}

/**
 * 
 * @export
 */
export type ContractRequestComment = {
    /**
     * ID
     * @type {number}
     * @memberof ContractRequestComment
     */
    id: number;
    /**
     * 契約書依頼のID
     * @type {number}
     * @memberof ContractRequestComment
     */
    requestId: number;
    /**
     * 種別
     * @type {string}
     * @memberof ContractRequestComment
     */
    type?: string;
    /**
     * コメント本文
     * @type {string}
     * @memberof ContractRequestComment
     */
    text?: string;
    /**
     * コメント補足 (システムからのコメントでユーザーが記入したテキストがある場合)
     * @type {string}
     * @memberof ContractRequestComment
     */
    subText?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof ContractRequestComment
     */
    fileId?: number;
    /**
     * 作成者
     * @type {number}
     * @memberof ContractRequestComment
     */
    createdBy?: number;
}

/**
 * 
 * @export
 */
export type ContractRequestCommentCreateInput = {
    /**
     * 本文
     * @type {string}
     * @memberof ContractRequestCommentCreateInput
     */
    text?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof ContractRequestCommentCreateInput
     */
    file?: FileInput;
}

/**
 * 
 * @export
 */
export type ContractRequestCommentUpdateInput = {
    /**
     * 本文
     * @type {string}
     * @memberof ContractRequestCommentUpdateInput
     */
    text?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof ContractRequestCommentUpdateInput
     */
    newFile?: FileInput;
    /**
     * 既存ファイルのID (ファイル削除する場合はNULL)
     * @type {number}
     * @memberof ContractRequestCommentUpdateInput
     */
    fileId?: number;
}

/**
 * 
 * @export
 */
export type ContractRequestFile = {
    /**
     * ID
     * @type {number}
     * @memberof ContractRequestFile
     */
    id: number;
    /**
     * 契約書依頼のID
     * @type {number}
     * @memberof ContractRequestFile
     */
    requestId: number;
    /**
     * メモ
     * @type {string}
     * @memberof ContractRequestFile
     */
    note?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof ContractRequestFile
     */
    fileId?: number;
    /**
     * 作成者
     * @type {number}
     * @memberof ContractRequestFile
     */
    createdBy?: number;
}

/**
 * 
 * @export
 */
export type ContractRequestInput = {
    /**
     * 種別 (creation | confirmation)
     * @type {string}
     * @memberof ContractRequestInput
     */
    type: string;
    /**
     * 下書きかどうか
     * @type {boolean}
     * @memberof ContractRequestInput
     */
    draft?: boolean;
    /**
     * 
     * @type {ContractCreationRequestInput}
     * @memberof ContractRequestInput
     */
    creationDetail?: ContractCreationRequestInput;
    /**
     * 
     * @type {ContractConfirmationRequestInput}
     * @memberof ContractRequestInput
     */
    confirmationDetail?: ContractConfirmationRequestInput;
}

/**
 * 共通条項一覧
 * @export
 */
export type ContractRequestList = {
    /**
     * 全件数
     * @type {number}
     * @memberof ContractRequestList
     */
    total: number;
    /**
     * 共通条項一覧
     * @type {Array<ContractRequest>}
     * @memberof ContractRequestList
     */
    items: Array<ContractRequest>;
}

/**
 * 
 * @export
 */
export type ContractRequestParameter = {
    /**
     * ID
     * @type {number}
     * @memberof ContractRequestParameter
     */
    id: number;
    /**
     * 契約書依頼のID
     * @type {number}
     * @memberof ContractRequestParameter
     */
    requestId: number;
    /**
     * 変数のID
     * @type {number}
     * @memberof ContractRequestParameter
     */
    variableId?: number;
    /**
     * 値
     * @type {string}
     * @memberof ContractRequestParameter
     */
    value?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof ContractRequestParameter
     */
    fileId?: number;
}

/**
 * 
 * @export
 */
export type ContractRequestParameterUpdateInput = {
    /**
     * 値
     * @type {string}
     * @memberof ContractRequestParameterUpdateInput
     */
    value: string;
}

/**
 * 
 * @export
 */
export type ContractRequestStateInput = {
    /**
     * ステータス
     * @type {string}
     * @memberof ContractRequestStateInput
     */
    state: string;
    /**
     * メモ
     * @type {string}
     * @memberof ContractRequestStateInput
     */
    note?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof ContractRequestStateInput
     */
    file?: FileInput;
    /**
     * ステータスの変更のみ強制定期に行う
     * @type {boolean}
     * @memberof ContractRequestStateInput
     */
    force?: boolean;
    /**
     * 収入印紙の負担者
     * @type {string}
     * @memberof ContractRequestStateInput
     */
    revenueStamp?: string;
    /**
     * 収入印紙の金額（単位：円）
     * @type {number}
     * @memberof ContractRequestStateInput
     */
    revenueStampAmount?: number;
}

/**
 * 
 * @export
 */
export type Corporation = {
    /**
     * ID
     * @type {number}
     * @memberof Corporation
     */
    id: number;
    /**
     * コード
     * @type {string}
     * @memberof Corporation
     */
    code: string;
    /**
     * 締結先名称
     * @type {string}
     * @memberof Corporation
     */
    name: string;
    /**
     * 企業名ヨミ
     * @type {string}
     * @memberof Corporation
     */
    yomi: string;
    /**
     * 様態
     * @type {string}
     * @memberof Corporation
     */
    type: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof Corporation
     */
    createdAt?: string;
    /**
     * 更新日時
     * @type {string}
     * @memberof Corporation
     */
    updatedAt?: string;
    /**
     * 削除日時
     * @type {string}
     * @memberof Corporation
     */
    deletedAt?: string;
}

/**
 * 企業詳細情報
 * @export
 */
export type CorporationDetail = {
    /**
     * 
     * @type {Corporation}
     * @memberof CorporationDetail
     */
    corporation: Corporation;
    /**
     * 操作ログ一覧
     * @type {Array<CorporationLog>}
     * @memberof CorporationDetail
     */
    logs: Array<CorporationLog>;
}

/**
 * 
 * @export
 */
export type CorporationInput = {
    /**
     * 締結先名称
     * @type {string}
     * @memberof CorporationInput
     */
    name: string;
    /**
     * 企業名ヨミ
     * @type {string}
     * @memberof CorporationInput
     */
    yomi?: string;
    /**
     * 様態
     * @type {string}
     * @memberof CorporationInput
     */
    type?: string;
}

/**
 * 企業一覧
 * @export
 */
export type CorporationList = {
    /**
     * 全件数
     * @type {number}
     * @memberof CorporationList
     */
    total: number;
    /**
     * 企業一覧
     * @type {Array<Corporation>}
     * @memberof CorporationList
     */
    items: Array<Corporation>;
}

/**
 * 
 * @export
 */
export type CorporationLog = {
    /**
     * ID
     * @type {number}
     * @memberof CorporationLog
     */
    id: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof CorporationLog
     */
    corporationId: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof CorporationLog
     */
    userId: number;
    /**
     * 操作種別
     * @type {string}
     * @memberof CorporationLog
     */
    operation: string;
    /**
     * 作成日時
     * @type {string}
     * @memberof CorporationLog
     */
    createdAt?: string;
}

/**
 * 
 * @export
 */
export type CurrentIpOutput = {
    /**
     * 現在のIPアドレス
     * @type {string}
     * @memberof CurrentIpOutput
     */
    ip: string;
}

/**
 * 
 * @export
 */
export type Customer = {
    /**
     * ID
     * @type {number}
     * @memberof Customer
     */
    id: number;
    /**
     * コード
     * @type {string}
     * @memberof Customer
     */
    code?: string;
    /**
     * 名称
     * @type {string}
     * @memberof Customer
     */
    name?: string;
    /**
     * 担当者姓
     * @type {string}
     * @memberof Customer
     */
    ownerFamilyName?: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof Customer
     */
    ownerGivenName?: string;
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof Customer
     */
    ownerEmail?: string;
    /**
     * CognitoユーザーID
     * @type {string}
     * @memberof Customer
     */
    ownerCognitoUserSub?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof Customer
     */
    phoneNumber?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof Customer
     */
    postalCode?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof Customer
     */
    prefecture?: string;
    /**
     * 住所
     * @type {string}
     * @memberof Customer
     */
    address?: string;
    /**
     * 住所2
     * @type {string}
     * @memberof Customer
     */
    address2?: string;
    /**
     * 住所3
     * @type {string}
     * @memberof Customer
     */
    address3?: string;
    /**
     * ユーザー数
     * @type {number}
     * @memberof Customer
     */
    userCount?: number;
    /**
     * 契約書数
     * @type {number}
     * @memberof Customer
     */
    contractCount?: number;
    /**
     * Amazon注文番号
     * @type {string}
     * @memberof Customer
     */
    orderNumber?: string;
    /**
     * Stripe顧客ID
     * @type {string}
     * @memberof Customer
     */
    stripeCustomerId?: string;
    /**
     * Paid会員ID
     * @type {string}
     * @memberof Customer
     */
    paidMemberId?: string;
    /**
     * アップロード制限
     * @type {Object}
     * @memberof Customer
     */
    uploadLimit?: Object;
    /**
     * ステータス
     * @type {string}
     * @memberof Customer
     */
    state?: string;
    /**
     * 初期パスワード変更が必要かどうか
     * @type {boolean}
     * @memberof Customer
     */
    isTemporaryPassword?: boolean;
}

/**
 * 削除結果
 * @export
 */
export type DeleteResult = {
    /**
     * 結果
     * @type {string}
     * @memberof DeleteResult
     */
    result: string;
}

/**
 * エラーオブジェクト
 * @export
 */
export type Error = {
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof Error
     */
    message: string;
}

/**
 * 
 * @export
 */
export type FileInput = {
    /**
     * ファイル名
     * @type {string}
     * @memberof FileInput
     */
    name: string;
    /**
     * ファイル本体(BASE64)
     * @type {string}
     * @memberof FileInput
     */
    data: string;
    /**
     * MIMEタイプ
     * @type {string}
     * @memberof FileInput
     */
    contentType: string;
}

/**
 * 
 * @export
 */
export type FilePreview = {
    /**
     * プレビュー(PDF/BASE64)
     * @type {string}
     * @memberof FilePreview
     */
    pdf: string;
}

/**
 * 
 * @export
 */
export type FilePreviewInput = {
    /**
     * ファイル(BASE64)
     * @type {string}
     * @memberof FilePreviewInput
     */
    data: string;
    /**
     * 拡張子 (docx)
     * @type {string}
     * @memberof FilePreviewInput
     */
    extention: string;
}

/**
 * 
 * @export
 */
export type Group = {
    /**
     * ID
     * @type {number}
     * @memberof Group
     */
    id: number;
    /**
     * 名称
     * @type {string}
     * @memberof Group
     */
    name: string;
    /**
     * 表示順
     * @type {number}
     * @memberof Group
     */
    position?: number;
    /**
     * 更新日時
     * @type {string}
     * @memberof Group
     */
    updatedAt?: string;
    /**
     * 削除日時
     * @type {string}
     * @memberof Group
     */
    deletedAt?: string;
}

/**
 * 
 * @export
 */
export type GroupInput = {
    /**
     * 部署名
     * @type {string}
     * @memberof GroupInput
     */
    name: string;
}

/**
 * 部署一覧
 * @export
 */
export type GroupList = {
    /**
     * 全件数
     * @type {number}
     * @memberof GroupList
     */
    total: number;
    /**
     * 部署一覧
     * @type {Array<Group>}
     * @memberof GroupList
     */
    items: Array<Group>;
}

/**
 * 
 * @export
 */
export type GroupPositionInput = {
    /**
     * 順序 -1:上に移動 1:下に移動
     * @type {number}
     * @memberof GroupPositionInput
     */
    direction: number;
}

/**
 * 
 * @export
 */
export type InputForgotPassword = {
    /**
     * メールアドレス
     * @type {string}
     * @memberof InputForgotPassword
     */
    email: string;
}

/**
 * 
 * @export
 */
export type InputNotifyExists = {
    /**
     * 
     * @type {string}
     * @memberof InputNotifyExists
     */
    email: string;
    /**
     * \'register\' または \'update\'
     * @type {string}
     * @memberof InputNotifyExists
     */
    type?: string;
}

/**
 * 
 * @export
 */
export type InputPaidAccountInfo = {
    /**
     * 法人名
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    companyName: string;
    /**
     * 法人名(カナ)
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    companyNameKana: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    zipCode: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    prefecture: string;
    /**
     * 住所1
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    address1: string;
    /**
     * 住所2
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    address2: string;
    /**
     * 住所3
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    address3?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    tel: string;
    /**
     * 代表者姓
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    representativeSei: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    representativeMei: string;
    /**
     * 代表者姓(カナ)
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    representativeSeiKana: string;
    /**
     * 代表者名(カナ)
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    representativeMeiKana: string;
    /**
     * 担当者姓
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    clerkSei: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    clerkMei: string;
    /**
     * 担当者姓(カナ)
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    clerkSeiKana: string;
    /**
     * 担当者名(カナ)
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    clerkMeiKana: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    email: string;
    /**
     * お支払いサイクル
     * @type {string}
     * @memberof InputPaidAccountInfo
     */
    closingDay: string;
}

/**
 * 
 * @export
 */
export type InputPaidComplete = {
    /**
     * Paidログイン認証コード
     * @type {string}
     * @memberof InputPaidComplete
     */
    loginAuthCode?: string;
    /**
     * 
     * @type {InputPaidAccountInfo}
     * @memberof InputPaidComplete
     */
    paidAccountInfo?: InputPaidAccountInfo;
}

/**
 * 
 * @export
 */
export type InputSignupOrganization = {
    /**
     * 担当者メールアドレス
     * @type {string}
     * @memberof InputSignupOrganization
     */
    email: string;
    /**
     * 組織名
     * @type {string}
     * @memberof InputSignupOrganization
     */
    organizationName: string;
    /**
     * 代表者姓
     * @type {string}
     * @memberof InputSignupOrganization
     */
    ownerFamilyName: string;
    /**
     * 代表者名
     * @type {string}
     * @memberof InputSignupOrganization
     */
    ownerGivenName: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof InputSignupOrganization
     */
    phoneNumber: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof InputSignupOrganization
     */
    postalCode: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof InputSignupOrganization
     */
    prefecture: string;
    /**
     * 住所
     * @type {string}
     * @memberof InputSignupOrganization
     */
    address: string;
    /**
     * 住所2
     * @type {string}
     * @memberof InputSignupOrganization
     */
    address2: string;
    /**
     * 住所3
     * @type {string}
     * @memberof InputSignupOrganization
     */
    address3?: string;
}

/**
 * 
 * @export
 */
export type InputSignupResendPassword = {
    /**
     * CognitoユーザーID
     * @type {string}
     * @memberof InputSignupResendPassword
     */
    cognitoUserSub: string;
}

/**
 * 
 * @export
 */
export type InputSignupReserveLicenseKey = {
    /**
     * ライセンスキー
     * @type {string}
     * @memberof InputSignupReserveLicenseKey
     */
    licenseKey: string;
    /**
     * Amazon注文番号
     * @type {string}
     * @memberof InputSignupReserveLicenseKey
     */
    orderNumber: string;
}

/**
 * 
 * @export
 */
export type InputSignupSetup = {
    /**
     * 支払い方法 (charge_automatically, send_invoice)
     * @type {string}
     * @memberof InputSignupSetup
     */
    collectionMethod: string;
    /**
     * StripeセッションID (支払い方法がcharge_automaticallyの場合のみ)
     * @type {string}
     * @memberof InputSignupSetup
     */
    sessionId?: string;
    /**
     * Paidログイン認証コード (支払い方法がsend_invoiceの場合かつ既存Paidアカウントの場合)
     * @type {string}
     * @memberof InputSignupSetup
     */
    loginAuthCode?: string;
    /**
     * Paidログイン認証結果コード (支払い方法がsend_invoiceの場合かつ既存Paidアカウントの場合)
     * @type {string}
     * @memberof InputSignupSetup
     */
    resultCode?: string;
    /**
     * 
     * @type {InputPaidAccountInfo}
     * @memberof InputSignupSetup
     */
    paidAccountInfo?: InputPaidAccountInfo;
}

/**
 * 
 * @export
 */
export type InputStripeComplete = {
    /**
     * StripeセッションID
     * @type {string}
     * @memberof InputStripeComplete
     */
    sessionId: string;
}

/**
 * 
 * @export
 */
export type InputUser = {
    /**
     * メールアドレス
     * @type {string}
     * @memberof InputUser
     */
    email: string;
    /**
     * 姓
     * @type {string}
     * @memberof InputUser
     */
    familyName: string;
    /**
     * 名
     * @type {string}
     * @memberof InputUser
     */
    givenName: string;
    /**
     * 2段階認証
     * @type {string}
     * @memberof InputUser
     */
    mfa: string;
    /**
     * 部署ID
     * @type {Array<number>}
     * @memberof InputUser
     */
    groupIds?: Array<number>;
    /**
     * 権限ID
     * @type {number}
     * @memberof InputUser
     */
    roleId: number;
}

/**
 * 
 * @export
 */
export type InputUserName = {
    /**
     * 姓
     * @type {string}
     * @memberof InputUserName
     */
    familyName: string;
    /**
     * 名
     * @type {string}
     * @memberof InputUserName
     */
    givenName: string;
}

/**
 * 
 * @export
 */
export type LicenseKey = {
    /**
     * ID
     * @type {number}
     * @memberof LicenseKey
     */
    id: number;
    /**
     * ライセンスキー
     * @type {string}
     * @memberof LicenseKey
     */
    value: string;
    /**
     * ステータス
     * @type {string}
     * @memberof LicenseKey
     */
    state: string;
    /**
     * タイプ
     * @type {string}
     * @memberof LicenseKey
     */
    type?: string;
    /**
     * 顧客ID
     * @type {number}
     * @memberof LicenseKey
     */
    customerId?: number;
}

/**
 * 
 * @export
 */
export type ModelFile = {
    /**
     * ID
     * @type {number}
     * @memberof ModelFile
     */
    id: number;
    /**
     * 種別
     * @type {string}
     * @memberof ModelFile
     */
    type: string;
    /**
     * ステータス
     * @type {string}
     * @memberof ModelFile
     */
    state: string;
    /**
     * 名称
     * @type {string}
     * @memberof ModelFile
     */
    name: string;
    /**
     * MIMEタイプ
     * @type {string}
     * @memberof ModelFile
     */
    contentType: string;
    /**
     * 
     * @type {User}
     * @memberof ModelFile
     */
    createdBy?: User;
}

/**
 * 
 * @export
 */
export type Notification = {
    /**
     * ID
     * @type {number}
     * @memberof Notification
     */
    id: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof Notification
     */
    userId?: number;
    /**
     * 種別
     * @type {string}
     * @memberof Notification
     */
    type: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof Notification
     */
    text: string;
    /**
     * リンクURL
     * @type {string}
     * @memberof Notification
     */
    link: string;
    /**
     * 契約書依頼ID
     * @type {number}
     * @memberof Notification
     */
    contractRequestId?: number;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof Notification
     */
    stampRequestId?: number;
    /**
     * 契約ID
     * @type {number}
     * @memberof Notification
     */
    contractId?: number;
}

/**
 * 
 * @export
 */
export type OperationLog = {
    /**
     * ID
     * @type {number}
     * @memberof OperationLog
     */
    id: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof OperationLog
     */
    userId?: number;
    /**
     * ユーザー名
     * @type {string}
     * @memberof OperationLog
     */
    userName?: string;
    /**
     * カテゴリ
     * @type {string}
     * @memberof OperationLog
     */
    category?: string;
    /**
     * 操作
     * @type {string}
     * @memberof OperationLog
     */
    operation?: string;
    /**
     * タイトル
     * @type {string}
     * @memberof OperationLog
     */
    title?: string;
    /**
     * 詳細
     * @type {string}
     * @memberof OperationLog
     */
    detail?: string;
    /**
     * コメント
     * @type {string}
     * @memberof OperationLog
     */
    comment?: string;
    /**
     * 対象ID
     * @type {number}
     * @memberof OperationLog
     */
    targetId?: number;
    /**
     * ファイルID
     * @type {number}
     * @memberof OperationLog
     */
    fileId?: number;
    /**
     * 作成日時
     * @type {string}
     * @memberof OperationLog
     */
    createdAt?: string;
}

/**
 * 操作ログ一覧
 * @export
 */
export type OperationLogList = {
    /**
     * 全件数
     * @type {number}
     * @memberof OperationLogList
     */
    total: number;
    /**
     * 操作ログ一覧
     * @type {Array<OperationLog>}
     * @memberof OperationLogList
     */
    items: Array<OperationLog>;
}

/**
 * 
 * @export
 */
export type OptionPlanInput = {
    /**
     * オプションプランの数
     * @type {number}
     * @memberof OptionPlanInput
     */
    optionLimitAmount: number;
}

/**
 * 
 * @export
 */
export type OutputCheckCustomer = {
    /**
     * 顧客ステータス
     * @type {string}
     * @memberof OutputCheckCustomer
     */
    state: string;
}

/**
 * 
 * @export
 */
export type OutputSignupOrganization = {
    /**
     * 初期パスワード変更が必要かどうか
     * @type {boolean}
     * @memberof OutputSignupOrganization
     */
    needsToChangePassword: boolean;
    /**
     * CognitoユーザーID
     * @type {string}
     * @memberof OutputSignupOrganization
     */
    cognitoUserSub: string;
}

/**
 * 
 * @export
 */
export type OutputSignupReserveLicenseKey = {
    /**
     * 成功メッセージ
     * @type {string}
     * @memberof OutputSignupReserveLicenseKey
     */
    message: string;
}

/**
 * 
 * @export
 */
export type OutputStripeSession = {
    /**
     * StripeセッションID
     * @type {string}
     * @memberof OutputStripeSession
     */
    sessionId: string;
    /**
     * StripeチェックアウトURL
     * @type {string}
     * @memberof OutputStripeSession
     */
    checkoutUrl: string;
}

/**
 * 
 * @export
 */
export type PaidOrder = {
    /**
     * ID
     * @type {number}
     * @memberof PaidOrder
     */
    id: number;
    /**
     * ステータス
     * @type {string}
     * @memberof PaidOrder
     */
    state: string;
    /**
     * クレジットID
     * @type {string}
     * @memberof PaidOrder
     */
    creditId: string;
    /**
     * Paid貴社番号
     * @type {string}
     * @memberof PaidOrder
     */
    memberId: string;
    /**
     * 顧客ID
     * @type {number}
     * @memberof PaidOrder
     */
    customerId?: number;
    /**
     * 内容
     * @type {string}
     * @memberof PaidOrder
     */
    contents?: string;
    /**
     * 金額
     * @type {number}
     * @memberof PaidOrder
     */
    price?: number;
    /**
     * 有効開始日
     * @type {string}
     * @memberof PaidOrder
     */
    effectiveAt?: string;
}

/**
 * 
 * @export
 */
export type Role = {
    /**
     * ID
     * @type {number}
     * @memberof Role
     */
    id: number;
    /**
     * 名称
     * @type {string}
     * @memberof Role
     */
    name: string;
    /**
     * 種別
     * @type {string}
     * @memberof Role
     */
    type: string;
    /**
     * 管理者かどうか
     * @type {boolean}
     * @memberof Role
     */
    admin: boolean;
    /**
     * 契約書依頼の閲覧権限
     * @type {string}
     * @memberof Role
     */
    readContractRequest: string;
    /**
     * 押捺申請の閲覧権限
     * @type {string}
     * @memberof Role
     */
    readStampRequest: string;
    /**
     * 契約の閲覧権限
     * @type {string}
     * @memberof Role
     */
    readContract: string;
    /**
     * 契約書依頼の作成権限
     * @type {boolean}
     * @memberof Role
     */
    createContractRequest: boolean;
    /**
     * 押捺申請の作成権限
     * @type {boolean}
     * @memberof Role
     */
    createStampRequest: boolean;
    /**
     * 契約の作成権限
     * @type {boolean}
     * @memberof Role
     */
    createContract: boolean;
    /**
     * 押捺申請の承認権限
     * @type {boolean}
     * @memberof Role
     */
    approveStampRequest: boolean;
    /**
     * テンプレートの編集権限
     * @type {boolean}
     * @memberof Role
     */
    editTemplate: boolean;
    /**
     * 共通条項の編集権限
     * @type {boolean}
     * @memberof Role
     */
    editCommonClause: boolean;
    /**
     * 変数の編集権限
     * @type {boolean}
     * @memberof Role
     */
    editVariable: boolean;
    /**
     * 法人の編集権限
     * @type {boolean}
     * @memberof Role
     */
    editCorporation: boolean;
    /**
     * 契約書フォームの編集権限
     * @type {boolean}
     * @memberof Role
     */
    editContractForm: boolean;
    /**
     * 契約通知の編集権限
     * @type {boolean}
     * @memberof Role
     */
    editContractNotification: boolean;
    /**
     * 承認ルートの編集権限
     * @type {boolean}
     * @memberof Role
     */
    editApprovalRoute: boolean;
    /**
     * メールの編集権限
     * @type {boolean}
     * @memberof Role
     */
    editEmail: boolean;
    /**
     * パスワードの編集権限
     * @type {boolean}
     * @memberof Role
     */
    editPassword: boolean;
    /**
     * ユーザー名の編集権限
     * @type {boolean}
     * @memberof Role
     */
    editUserName: boolean;
}

/**
 * 
 * @export
 */
export type RoleInput = {
    /**
     * 部署名
     * @type {string}
     * @memberof RoleInput
     */
    name: string;
    /**
     * 種別
     * @type {string}
     * @memberof RoleInput
     */
    type: string;
    /**
     * 管理者かどうか
     * @type {boolean}
     * @memberof RoleInput
     */
    admin: boolean;
    /**
     * 契約書依頼の閲覧権限
     * @type {string}
     * @memberof RoleInput
     */
    readContractRequest: string;
    /**
     * 押捺申請の閲覧権限
     * @type {string}
     * @memberof RoleInput
     */
    readStampRequest: string;
    /**
     * 契約の閲覧権限
     * @type {string}
     * @memberof RoleInput
     */
    readContract: string;
    /**
     * 契約書依頼の作成権限
     * @type {boolean}
     * @memberof RoleInput
     */
    createContractRequest: boolean;
    /**
     * 押捺申請の作成権限
     * @type {boolean}
     * @memberof RoleInput
     */
    createStampRequest: boolean;
    /**
     * 契約の作成権限
     * @type {boolean}
     * @memberof RoleInput
     */
    createContract: boolean;
    /**
     * 押捺申請の承認権限
     * @type {boolean}
     * @memberof RoleInput
     */
    approveStampRequest: boolean;
    /**
     * テンプレートの編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editTemplate: boolean;
    /**
     * 共通条項の編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editCommonClause: boolean;
    /**
     * 変数の編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editVariable: boolean;
    /**
     * 法人の編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editCorporation: boolean;
    /**
     * 契約書フォームの編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editContractForm: boolean;
    /**
     * 契約通知の編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editContractNotification: boolean;
    /**
     * 承認ルートの編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editApprovalRoute: boolean;
    /**
     * メールの編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editEmail: boolean;
    /**
     * パスワードの編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editPassword: boolean;
    /**
     * ユーザー名の編集権限
     * @type {boolean}
     * @memberof RoleInput
     */
    editUserName: boolean;
}

/**
 * 権限一覧
 * @export
 */
export type RoleList = {
    /**
     * 全件数
     * @type {number}
     * @memberof RoleList
     */
    total: number;
    /**
     * 権限一覧
     * @type {Array<Role>}
     * @memberof RoleList
     */
    items: Array<Role>;
}

/**
 * 
 * @export
 */
export type StampApproval = {
    /**
     * ID
     * @type {number}
     * @memberof StampApproval
     */
    id: number;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof StampApproval
     */
    requestId: number;
    /**
     * 承認者ID
     * @type {number}
     * @memberof StampApproval
     */
    userId?: number;
    /**
     * 承認者氏名(過去データのみ)
     * @type {string}
     * @memberof StampApproval
     */
    userName?: string;
    /**
     * 役割
     * @type {string}
     * @memberof StampApproval
     */
    role?: string;
    /**
     * ステータス
     * @type {string}
     * @memberof StampApproval
     */
    state: string;
    /**
     * 順序
     * @type {number}
     * @memberof StampApproval
     */
    position: number;
}

/**
 * 
 * @export
 */
export type StampApprovalInput = {
    /**
     * 承認者のID
     * @type {number}
     * @memberof StampApprovalInput
     */
    userId?: number;
}

/**
 * 
 * @export
 */
export type StampApprovalRoute = {
    /**
     * ID
     * @type {number}
     * @memberof StampApprovalRoute
     */
    id: number;
    /**
     * タイトル
     * @type {string}
     * @memberof StampApprovalRoute
     */
    title: string;
    /**
     * 説明
     * @type {string}
     * @memberof StampApprovalRoute
     */
    description?: string;
    /**
     * 作成者
     * @type {number}
     * @memberof StampApprovalRoute
     */
    createdBy?: number;
    /**
     * 最終更新者
     * @type {number}
     * @memberof StampApprovalRoute
     */
    updatedBy?: number;
}

/**
 * 
 * @export
 */
export type StampApprovalRouteInput = {
    /**
     * タイトル
     * @type {string}
     * @memberof StampApprovalRouteInput
     */
    title: string;
    /**
     * 説明
     * @type {string}
     * @memberof StampApprovalRouteInput
     */
    description?: string;
    /**
     * 承認者
     * @type {Array<StampApprovalRouteItemInput>}
     * @memberof StampApprovalRouteInput
     */
    items: Array<StampApprovalRouteItemInput>;
    /**
     * 申請フォーム情報
     * @type {Array<StampApprovalRouteVariableInput>}
     * @memberof StampApprovalRouteInput
     */
    variables: Array<StampApprovalRouteVariableInput>;
}

/**
 * 
 * @export
 */
export type StampApprovalRouteItem = {
    /**
     * ID
     * @type {number}
     * @memberof StampApprovalRouteItem
     */
    id: number;
    /**
     * 承認経路ID
     * @type {number}
     * @memberof StampApprovalRouteItem
     */
    routeId: number;
    /**
     * 承認者のユーザーID、NULLの場合は申請者による登録
     * @type {number}
     * @memberof StampApprovalRouteItem
     */
    userId?: number;
    /**
     * 役割
     * @type {string}
     * @memberof StampApprovalRouteItem
     */
    role: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof StampApprovalRouteItem
     */
    required: boolean;
    /**
     * 順序
     * @type {number}
     * @memberof StampApprovalRouteItem
     */
    position: number;
}

/**
 * 
 * @export
 */
export type StampApprovalRouteItemInput = {
    /**
     * ID(既存の場合)
     * @type {number}
     * @memberof StampApprovalRouteItemInput
     */
    id?: number;
    /**
     * 承認者のID
     * @type {number}
     * @memberof StampApprovalRouteItemInput
     */
    userId?: number;
    /**
     * 役割
     * @type {string}
     * @memberof StampApprovalRouteItemInput
     */
    role: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof StampApprovalRouteItemInput
     */
    required: boolean;
}

/**
 * 承認経路一覧
 * @export
 */
export type StampApprovalRouteList = {
    /**
     * 全件数
     * @type {number}
     * @memberof StampApprovalRouteList
     */
    total: number;
    /**
     * 押捺申請経路一覧
     * @type {Array<StampApprovalRoute>}
     * @memberof StampApprovalRouteList
     */
    items: Array<StampApprovalRoute>;
}

/**
 * 
 * @export
 */
export type StampApprovalRouteVariable = {
    /**
     * ID
     * @type {number}
     * @memberof StampApprovalRouteVariable
     */
    id: number;
    /**
     * 押捺申請経路ID
     * @type {number}
     * @memberof StampApprovalRouteVariable
     */
    stampApprovalRouteId: number;
    /**
     * 変数ID
     * @type {number}
     * @memberof StampApprovalRouteVariable
     */
    variableId: number;
    /**
     * 押捺申請経路内での順序
     * @type {number}
     * @memberof StampApprovalRouteVariable
     */
    position: number;
}

/**
 * 
 * @export
 */
export type StampApprovalRouteVariableInput = {
    /**
     * 名前
     * @type {string}
     * @memberof StampApprovalRouteVariableInput
     */
    name: string;
    /**
     * 種別
     * @type {string}
     * @memberof StampApprovalRouteVariableInput
     */
    type: string;
    /**
     * 種別詳細
     * @type {string}
     * @memberof StampApprovalRouteVariableInput
     */
    typeDetail: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof StampApprovalRouteVariableInput
     */
    required: boolean;
    /**
     * 説明
     * @type {string}
     * @memberof StampApprovalRouteVariableInput
     */
    description: string;
}

/**
 * 
 * @export
 */
export type StampRequest = {
    /**
     * ID
     * @type {number}
     * @memberof StampRequest
     */
    id: number;
    /**
     * ステータス
     * @type {string}
     * @memberof StampRequest
     */
    state: string;
    /**
     * 申請者のユーザーID
     * @type {number}
     * @memberof StampRequest
     */
    userId?: number;
    /**
     * ユーザー名(過去データ用)
     * @type {string}
     * @memberof StampRequest
     */
    userName?: string;
    /**
     * 承認経路ID
     * @type {number}
     * @memberof StampRequest
     */
    approvalRouteId: number;
    /**
     * 書類名
     * @type {string}
     * @memberof StampRequest
     */
    title: string;
    /**
     * 取引先名
     * @type {string}
     * @memberof StampRequest
     */
    partner: string;
}

/**
 * 
 * @export
 */
export type StampRequestApproveInput = {
    /**
     * コメント
     * @type {string}
     * @memberof StampRequestApproveInput
     */
    text?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestApproveInput
     */
    file?: FileInput;
}

/**
 * 
 * @export
 */
export type StampRequestComment = {
    /**
     * ID
     * @type {number}
     * @memberof StampRequestComment
     */
    id: number;
    /**
     * 押捺申請のID
     * @type {number}
     * @memberof StampRequestComment
     */
    requestId: number;
    /**
     * 種別
     * @type {string}
     * @memberof StampRequestComment
     */
    type?: string;
    /**
     * コメント本文
     * @type {string}
     * @memberof StampRequestComment
     */
    text?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof StampRequestComment
     */
    fileId?: number;
    /**
     * 作成者
     * @type {number}
     * @memberof StampRequestComment
     */
    createdBy?: number;
}

/**
 * 
 * @export
 */
export type StampRequestEditInput = {
    /**
     * コメント
     * @type {string}
     * @memberof StampRequestEditInput
     */
    text?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestEditInput
     */
    file?: FileInput;
    /**
     * 修正理由
     * @type {string}
     * @memberof StampRequestEditInput
     */
    reason: string;
}

/**
 * 
 * @export
 */
export type StampRequestInput = {
    /**
     * タイトル
     * @type {string}
     * @memberof StampRequestInput
     */
    title: string;
    /**
     * 取引先名
     * @type {string}
     * @memberof StampRequestInput
     */
    partner: string;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestInput
     */
    file?: FileInput;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestInput
     */
    previewFile?: FileInput;
    /**
     * ファイルID
     * @type {number}
     * @memberof StampRequestInput
     */
    fileId?: number;
    /**
     * -契約開始日
     * @type {string}
     * @memberof StampRequestInput
     */
    startDate?: string;
    /**
     * -契約開始日
     * @type {string}
     * @memberof StampRequestInput
     */
    endDate?: string;
    /**
     * -自動更新の有無
     * @type {boolean}
     * @memberof StampRequestInput
     */
    renewal: boolean;
    /**
     * -承認経路ID
     * @type {number}
     * @memberof StampRequestInput
     */
    approvalRouteId: number;
    /**
     * 契約書依頼ID
     * @type {number}
     * @memberof StampRequestInput
     */
    contractRequestId?: number;
    /**
     * 申請フォーム情報
     * @type {Array<StampRequestParameterInput>}
     * @memberof StampRequestInput
     */
    parameters: Array<StampRequestParameterInput>;
    /**
     * 承認経路
     * @type {Array<StampApprovalInput>}
     * @memberof StampRequestInput
     */
    approvals: Array<StampApprovalInput>;
    /**
     * 下書きかどうか
     * @type {boolean}
     * @memberof StampRequestInput
     */
    draft?: boolean;
}

/**
 * 押捺申請一覧
 * @export
 */
export type StampRequestList = {
    /**
     * 全件数
     * @type {number}
     * @memberof StampRequestList
     */
    total: number;
    /**
     * 押捺申請一覧
     * @type {Array<StampRequest>}
     * @memberof StampRequestList
     */
    items: Array<StampRequest>;
}

/**
 * 
 * @export
 */
export type StampRequestLog = {
    /**
     * ID
     * @type {number}
     * @memberof StampRequestLog
     */
    id: number;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof StampRequestLog
     */
    requestId: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof StampRequestLog
     */
    userId: number;
    /**
     * ユーザー名
     * @type {string}
     * @memberof StampRequestLog
     */
    userName?: string;
    /**
     * 役割
     * @type {string}
     * @memberof StampRequestLog
     */
    role?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof StampRequestLog
     */
    fileId?: number;
    /**
     * 操作
     * @type {string}
     * @memberof StampRequestLog
     */
    action: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof StampRequestLog
     */
    message?: string;
    /**
     * 修正済み
     * @type {boolean}
     * @memberof StampRequestLog
     */
    corrected?: boolean;
    /**
     * 修正理由
     * @type {string}
     * @memberof StampRequestLog
     */
    reason?: string;
}

/**
 * 
 * @export
 */
export type StampRequestParameter = {
    /**
     * ID
     * @type {number}
     * @memberof StampRequestParameter
     */
    id: number;
    /**
     * 押捺申請のID
     * @type {number}
     * @memberof StampRequestParameter
     */
    requestId: number;
    /**
     * 変数のID
     * @type {number}
     * @memberof StampRequestParameter
     */
    variableId?: number;
    /**
     * 値
     * @type {string}
     * @memberof StampRequestParameter
     */
    value?: string;
    /**
     * ファイルID
     * @type {number}
     * @memberof StampRequestParameter
     */
    fileId?: number;
}

/**
 * 
 * @export
 */
export type StampRequestParameterInput = {
    /**
     * 変数ID
     * @type {number}
     * @memberof StampRequestParameterInput
     */
    variableId: number;
    /**
     * 値
     * @type {string}
     * @memberof StampRequestParameterInput
     */
    value?: string;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestParameterInput
     */
    file?: FileInput;
    /**
     * ファイルID(更新時に既存のファイルを残す場合に指定)
     * @type {number}
     * @memberof StampRequestParameterInput
     */
    fileId?: number;
}

/**
 * 
 * @export
 */
export type StampRequestRejectInput = {
    /**
     * コメント
     * @type {string}
     * @memberof StampRequestRejectInput
     */
    text: string;
    /**
     * 
     * @type {FileInput}
     * @memberof StampRequestRejectInput
     */
    file?: FileInput;
}

/**
 * 
 * @export
 */
export type Template = {
    /**
     * ID
     * @type {number}
     * @memberof Template
     */
    id: number;
    /**
     * テンプレート名
     * @type {string}
     * @memberof Template
     */
    name: string;
    /**
     * 説明文
     * @type {string}
     * @memberof Template
     */
    description?: string;
    /**
     * 契約書タイトル
     * @type {string}
     * @memberof Template
     */
    title: string;
    /**
     * 前文
     * @type {string}
     * @memberof Template
     */
    preamble: string;
    /**
     * 後文
     * @type {string}
     * @memberof Template
     */
    postamble: string;
    /**
     * 印紙有無
     * @type {boolean}
     * @memberof Template
     */
    stamp: boolean;
    /**
     * 署名欄の件数
     * @type {number}
     * @memberof Template
     */
    signatureCount: number;
    /**
     * プレビュー用HTML
     * @type {number}
     * @memberof Template
     */
    previewFileId: number;
    /**
     * 
     * @type {User}
     * @memberof Template
     */
    createdBy?: User;
    /**
     * 
     * @type {User}
     * @memberof Template
     */
    updatedBy?: User;
    /**
     * プレビューの更新が必要かどうか
     * @type {boolean}
     * @memberof Template
     */
    needsUpdatePreview?: boolean;
}

/**
 * 
 * @export
 */
export type TemplateClauseInput = {
    /**
     * 条項タイトル
     * @type {string}
     * @memberof TemplateClauseInput
     */
    title?: string;
    /**
     * 本文(Markdown)
     * @type {string}
     * @memberof TemplateClauseInput
     */
    body?: string;
    /**
     * 共通条項ID
     * @type {number}
     * @memberof TemplateClauseInput
     */
    commonId?: number;
}

/**
 * 
 * @export
 */
export type TemplateDocx = {
    /**
     * docx(BASE64)
     * @type {string}
     * @memberof TemplateDocx
     */
    docx: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof TemplateDocx
     */
    filename: string;
}

/**
 * 
 * @export
 */
export type TemplateInput = {
    /**
     * テンプレート名
     * @type {string}
     * @memberof TemplateInput
     */
    name: string;
    /**
     * タイトル
     * @type {string}
     * @memberof TemplateInput
     */
    title: string;
    /**
     * 前文
     * @type {string}
     * @memberof TemplateInput
     */
    preamble: string;
    /**
     * 後文
     * @type {string}
     * @memberof TemplateInput
     */
    postamble: string;
    /**
     * 印紙
     * @type {boolean}
     * @memberof TemplateInput
     */
    stamp: boolean;
    /**
     * 署名数
     * @type {number}
     * @memberof TemplateInput
     */
    signatureCount: number;
    /**
     * 説明
     * @type {string}
     * @memberof TemplateInput
     */
    description: string;
    /**
     * 条項
     * @type {Array<TemplateClauseInput>}
     * @memberof TemplateInput
     */
    clauses: Array<TemplateClauseInput>;
    /**
     * 変数
     * @type {Array<TemplateVariableInput>}
     * @memberof TemplateInput
     */
    variables: Array<TemplateVariableInput>;
}

/**
 * テンプレート一覧
 * @export
 */
export type TemplateList = {
    /**
     * 全件数
     * @type {number}
     * @memberof TemplateList
     */
    total: number;
    /**
     * テンプレート一覧
     * @type {Array<Template>}
     * @memberof TemplateList
     */
    items: Array<Template>;
}

/**
 * 
 * @export
 */
export type TemplatePreview = {
    /**
     * PDF(BASE64)
     * @type {string}
     * @memberof TemplatePreview
     */
    pdf: string;
}

/**
 * 
 * @export
 */
export type TemplatePreviewInput = {
    /**
     * タイトル
     * @type {string}
     * @memberof TemplatePreviewInput
     */
    title: string;
    /**
     * 前文
     * @type {string}
     * @memberof TemplatePreviewInput
     */
    preamble: string;
    /**
     * 後文
     * @type {string}
     * @memberof TemplatePreviewInput
     */
    postamble: string;
    /**
     * 印紙
     * @type {boolean}
     * @memberof TemplatePreviewInput
     */
    stamp: boolean;
    /**
     * 署名数
     * @type {number}
     * @memberof TemplatePreviewInput
     */
    signatureCount: number;
    /**
     * 条項
     * @type {Array<TemplateClauseInput>}
     * @memberof TemplatePreviewInput
     */
    clauses: Array<TemplateClauseInput>;
}

/**
 * 
 * @export
 */
export type TemplateVariable = {
    /**
     * ID
     * @type {number}
     * @memberof TemplateVariable
     */
    id: number;
    /**
     * テンプレートID
     * @type {number}
     * @memberof TemplateVariable
     */
    templateId: number;
    /**
     * 変数ID
     * @type {number}
     * @memberof TemplateVariable
     */
    variableId: number;
    /**
     * テンプレート内での順序
     * @type {number}
     * @memberof TemplateVariable
     */
    position: number;
}

/**
 * 
 * @export
 */
export type TemplateVariableInput = {
    /**
     * ID(共通条項の変数の場合)
     * @type {number}
     * @memberof TemplateVariableInput
     */
    id: number;
    /**
     * 名前
     * @type {string}
     * @memberof TemplateVariableInput
     */
    name: string;
    /**
     * 種別
     * @type {string}
     * @memberof TemplateVariableInput
     */
    type: string;
    /**
     * 種別詳細
     * @type {string}
     * @memberof TemplateVariableInput
     */
    typeDetail: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof TemplateVariableInput
     */
    required: boolean;
    /**
     * 本文に含まれるかどうか
     * @type {boolean}
     * @memberof TemplateVariableInput
     */
    within: boolean;
    /**
     * 説明
     * @type {string}
     * @memberof TemplateVariableInput
     */
    description: string;
}

/**
 * 
 * @export
 */
export type Unread = {
    /**
     * ID
     * @type {number}
     * @memberof Unread
     */
    id: number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof Unread
     */
    userId?: number;
    /**
     * 契約書依頼ID
     * @type {number}
     * @memberof Unread
     */
    contractRequestId?: number;
    /**
     * 押捺申請ID
     * @type {number}
     * @memberof Unread
     */
    stampRequestId?: number;
    /**
     * 契約ID
     * @type {number}
     * @memberof Unread
     */
    contractId?: number;
}

/**
 * 
 * @export
 */
export type UpcomingInvoice = {
    /**
     * 請求日
     * @type {string}
     * @memberof UpcomingInvoice
     */
    _date: string;
    /**
     * 請求金額
     * @type {string}
     * @memberof UpcomingInvoice
     */
    amount: string;
}

/**
 * 
 * @export
 */
export type User = {
    /**
     * ID
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * メールアドレス
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 姓
     * @type {string}
     * @memberof User
     */
    familyName?: string;
    /**
     * 名
     * @type {string}
     * @memberof User
     */
    givenName?: string;
    /**
     * 名前
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * cognitoのユーザーSub
     * @type {string}
     * @memberof User
     */
    cognitoUserSub?: string;
    /**
     * 2段階認証
     * @type {string}
     * @memberof User
     */
    mfa?: string;
}

/**
 * ユーザー一覧
 * @export
 */
export type UserList = {
    /**
     * 全件数
     * @type {number}
     * @memberof UserList
     */
    total: number;
    /**
     * ユーザー一覧
     * @type {Array<User>}
     * @memberof UserList
     */
    users: Array<User>;
}

/**
 * 
 * @export
 */
export type UserMfa = {
    /**
     * 2段階認証の設定が必要かどうか
     * @type {boolean}
     * @memberof UserMfa
     */
    setupRequired: boolean;
    /**
     * 2段階認証の種類
     * @type {string}
     * @memberof UserMfa
     */
    mfa?: string;
}

/**
 * 
 * @export
 */
export type Variable = {
    /**
     * ID
     * @type {number}
     * @memberof Variable
     */
    id: number;
    /**
     * 名前
     * @type {string}
     * @memberof Variable
     */
    name: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof Variable
     */
    required: boolean;
    /**
     * 種別
     * @type {string}
     * @memberof Variable
     */
    type: string;
    /**
     * 種別詳細
     * @type {Object}
     * @memberof Variable
     */
    typeDetail?: Object;
    /**
     * 本文に含まれるかどうか
     * @type {boolean}
     * @memberof Variable
     */
    within?: boolean;
    /**
     * 説明
     * @type {string}
     * @memberof Variable
     */
    description?: string;
    /**
     * 共通変数ID (通常はnull)
     * @type {number}
     * @memberof Variable
     */
    commonId?: number;
    /**
     * デフォルト変数
     * @type {boolean}
     * @memberof Variable
     */
    predefined?: boolean;
    /**
     * 契約相手を表す変数かどうか
     * @type {boolean}
     * @memberof Variable
     */
    partner?: boolean;
}

/**
 * 
 * @export
 */
export type VariableInput = {
    /**
     * 変数名
     * @type {string}
     * @memberof VariableInput
     */
    name: string;
    /**
     * 種類
     * @type {string}
     * @memberof VariableInput
     */
    type: string;
    /**
     * 種類詳細
     * @type {string}
     * @memberof VariableInput
     */
    typeDetail: string;
    /**
     * 説明
     * @type {string}
     * @memberof VariableInput
     */
    description: string;
    /**
     * 必須かどうか
     * @type {boolean}
     * @memberof VariableInput
     */
    required: boolean;
}

/**
 * テンプレート一覧
 * @export
 */
export type VariableList = {
    /**
     * 全件数
     * @type {number}
     * @memberof VariableList
     */
    total: number;
    /**
     * 共通変数一覧
     * @type {Array<Variable>}
     * @memberof VariableList
     */
    items: Array<Variable>;
}



/**
 * AIApi - fetch parameter creator
 * @export
 */
export const AIApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary BedRockで契約書の各項目を抽出する
         * @throws {RequiredError}
         */
        aiExtractContractFormValuesPost(aiExtractContractFormValuesInput: AiExtractContractFormValuesInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'aiExtractContractFormValuesInput' is not null or undefined
            if (aiExtractContractFormValuesInput === null || aiExtractContractFormValuesInput === undefined) {
                throw new RequiredError('aiExtractContractFormValuesInput','Required parameter aiExtractContractFormValuesInput was null or undefined when calling aiExtractContractFormValuesPost.');
            }
            const localVarPath = `/ai/extractContractFormValues`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof aiExtractContractFormValuesInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(aiExtractContractFormValuesInput != null ? aiExtractContractFormValuesInput : {}) : (((aiExtractContractFormValuesInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type AIApiType = { 
    aiExtractContractFormValuesPost(aiExtractContractFormValuesInput: AiExtractContractFormValuesInput, options?: RequestOptions): Promise<AiExtractContractFormValuesResponse>,
}

/**
 * AIApi - factory function to inject configuration 
 * @export
 */
export const AIApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): AIApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary BedRockで契約書の各項目を抽出する
         * @throws {RequiredError}
         */
        aiExtractContractFormValuesPost(aiExtractContractFormValuesInput: AiExtractContractFormValuesInput, options?: RequestOptions = {}): Promise<AiExtractContractFormValuesResponse> {
            const localVarFetchArgs = AIApiFetchParamCreator(configuration).aiExtractContractFormValuesPost(aiExtractContractFormValuesInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * AccountApi - fetch parameter creator
 * @export
 */
export const AccountApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Stripe Billing Portalセッションを作成
         * @throws {RequiredError}
         */
        accountBillingPortalSessionGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/account/billingPortalSession`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 解約申し込みの取り消し
         * @throws {RequiredError}
         */
        accountCancelDelete(options: RequestOptions): FetchArgs {
            const localVarPath = `/account/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 解約申し込み
         * @throws {RequiredError}
         */
        accountCancelPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/account/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary オプションプランを更新
         * @throws {RequiredError}
         */
        accountOptionPlanPost(optionPlanInput: OptionPlanInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'optionPlanInput' is not null or undefined
            if (optionPlanInput === null || optionPlanInput === undefined) {
                throw new RequiredError('optionPlanInput','Required parameter optionPlanInput was null or undefined when calling accountOptionPlanPost.');
            }
            const localVarPath = `/account/optionPlan`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof optionPlanInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(optionPlanInput != null ? optionPlanInput : {}) : (((optionPlanInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paidアカウントとの連携を完了させる
         * @throws {RequiredError}
         */
        accountPaidCompletePost(inputPaidComplete: InputPaidComplete, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputPaidComplete' is not null or undefined
            if (inputPaidComplete === null || inputPaidComplete === undefined) {
                throw new RequiredError('inputPaidComplete','Required parameter inputPaidComplete was null or undefined when calling accountPaidCompletePost.');
            }
            const localVarPath = `/account/paidComplete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputPaidComplete !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputPaidComplete != null ? inputPaidComplete : {}) : (((inputPaidComplete:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 支払い方法方法のStripeへの変更処理を完了させる
         * @throws {RequiredError}
         */
        accountStripeCompletePost(inputStripeComplete: InputStripeComplete, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputStripeComplete' is not null or undefined
            if (inputStripeComplete === null || inputStripeComplete === undefined) {
                throw new RequiredError('inputStripeComplete','Required parameter inputStripeComplete was null or undefined when calling accountStripeCompletePost.');
            }
            const localVarPath = `/account/stripeComplete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputStripeComplete !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputStripeComplete != null ? inputStripeComplete : {}) : (((inputStripeComplete:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stripeセッションを取得
         * @throws {RequiredError}
         */
        accountStripeSessionPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/account/stripeSession`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 次回請求書を取得
         * @throws {RequiredError}
         */
        accountUpcomingInvoiceGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/account/upcomingInvoice`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type AccountApiType = { 
    accountBillingPortalSessionGet(options?: RequestOptions): Promise<BillingPortalSession>,

    accountCancelDelete(options?: RequestOptions): Promise<Object>,

    accountCancelPost(options?: RequestOptions): Promise<Object>,

    accountOptionPlanPost(optionPlanInput: OptionPlanInput, options?: RequestOptions): Promise<Object>,

    accountPaidCompletePost(inputPaidComplete: InputPaidComplete, options?: RequestOptions): Promise<Object>,

    accountStripeCompletePost(inputStripeComplete: InputStripeComplete, options?: RequestOptions): Promise<Object>,

    accountStripeSessionPost(options?: RequestOptions): Promise<OutputStripeSession>,

    accountUpcomingInvoiceGet(options?: RequestOptions): Promise<UpcomingInvoice>,
}

/**
 * AccountApi - factory function to inject configuration 
 * @export
 */
export const AccountApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): AccountApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary Stripe Billing Portalセッションを作成
         * @throws {RequiredError}
         */
        accountBillingPortalSessionGet(options?: RequestOptions = {}): Promise<BillingPortalSession> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountBillingPortalSessionGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 解約申し込みの取り消し
         * @throws {RequiredError}
         */
        accountCancelDelete(options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountCancelDelete(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 解約申し込み
         * @throws {RequiredError}
         */
        accountCancelPost(options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountCancelPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary オプションプランを更新
         * @throws {RequiredError}
         */
        accountOptionPlanPost(optionPlanInput: OptionPlanInput, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountOptionPlanPost(optionPlanInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary Paidアカウントとの連携を完了させる
         * @throws {RequiredError}
         */
        accountPaidCompletePost(inputPaidComplete: InputPaidComplete, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountPaidCompletePost(inputPaidComplete, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 支払い方法方法のStripeへの変更処理を完了させる
         * @throws {RequiredError}
         */
        accountStripeCompletePost(inputStripeComplete: InputStripeComplete, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountStripeCompletePost(inputStripeComplete, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary Stripeセッションを取得
         * @throws {RequiredError}
         */
        accountStripeSessionPost(options?: RequestOptions = {}): Promise<OutputStripeSession> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountStripeSessionPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 次回請求書を取得
         * @throws {RequiredError}
         */
        accountUpcomingInvoiceGet(options?: RequestOptions = {}): Promise<UpcomingInvoice> {
            const localVarFetchArgs = AccountApiFetchParamCreator(configuration).accountUpcomingInvoiceGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ArchiveApi - fetch parameter creator
 * @export
 */
export const ArchiveApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary アーカイブを取得
         * @throws {RequiredError}
         */
        archiveGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/archive`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ArchiveApiType = { 
    archiveGet(options?: RequestOptions): Promise<Archive>,
}

/**
 * ArchiveApi - factory function to inject configuration 
 * @export
 */
export const ArchiveApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ArchiveApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary アーカイブを取得
         * @throws {RequiredError}
         */
        archiveGet(options?: RequestOptions = {}): Promise<Archive> {
            const localVarFetchArgs = ArchiveApiFetchParamCreator(configuration).archiveGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * CommonClauseApi - fetch parameter creator
 * @export
 */
export const CommonClauseApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 共通条項一覧を取得
         * @throws {RequiredError}
         */
        commonClauseGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/commonClause`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通条項削除
         * @throws {RequiredError}
         */
        commonClauseIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling commonClauseIdDelete.');
            }
            const localVarPath = `/commonClause/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通条項情報を取得
         * @throws {RequiredError}
         */
        commonClauseIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling commonClauseIdGet.');
            }
            const localVarPath = `/commonClause/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通条項更新
         * @throws {RequiredError}
         */
        commonClauseIdPut(id: number, commonClauseInput: CommonClauseInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling commonClauseIdPut.');
            }
            // verify required parameter 'commonClauseInput' is not null or undefined
            if (commonClauseInput === null || commonClauseInput === undefined) {
                throw new RequiredError('commonClauseInput','Required parameter commonClauseInput was null or undefined when calling commonClauseIdPut.');
            }
            const localVarPath = `/commonClause/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof commonClauseInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(commonClauseInput != null ? commonClauseInput : {}) : (((commonClauseInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通条項新規作成
         * @throws {RequiredError}
         */
        commonClausePost(commonClauseInput: CommonClauseInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'commonClauseInput' is not null or undefined
            if (commonClauseInput === null || commonClauseInput === undefined) {
                throw new RequiredError('commonClauseInput','Required parameter commonClauseInput was null or undefined when calling commonClausePost.');
            }
            const localVarPath = `/commonClause`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof commonClauseInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(commonClauseInput != null ? commonClauseInput : {}) : (((commonClauseInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type CommonClauseApiType = { 
    commonClauseGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<CommonClauseList>,

    commonClauseIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    commonClauseIdGet(id: number, options?: RequestOptions): Promise<CommonClause>,

    commonClauseIdPut(id: number, commonClauseInput: CommonClauseInput, options?: RequestOptions): Promise<CommonClause>,

    commonClausePost(commonClauseInput: CommonClauseInput, options?: RequestOptions): Promise<CommonClause>,
}

/**
 * CommonClauseApi - factory function to inject configuration 
 * @export
 */
export const CommonClauseApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): CommonClauseApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 共通条項一覧を取得
         * @throws {RequiredError}
         */
        commonClauseGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<CommonClauseList> {
            const localVarFetchArgs = CommonClauseApiFetchParamCreator(configuration).commonClauseGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通条項削除
         * @throws {RequiredError}
         */
        commonClauseIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = CommonClauseApiFetchParamCreator(configuration).commonClauseIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通条項情報を取得
         * @throws {RequiredError}
         */
        commonClauseIdGet(id: number, options?: RequestOptions = {}): Promise<CommonClause> {
            const localVarFetchArgs = CommonClauseApiFetchParamCreator(configuration).commonClauseIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通条項更新
         * @throws {RequiredError}
         */
        commonClauseIdPut(id: number, commonClauseInput: CommonClauseInput, options?: RequestOptions = {}): Promise<CommonClause> {
            const localVarFetchArgs = CommonClauseApiFetchParamCreator(configuration).commonClauseIdPut(id, commonClauseInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通条項新規作成
         * @throws {RequiredError}
         */
        commonClausePost(commonClauseInput: CommonClauseInput, options?: RequestOptions = {}): Promise<CommonClause> {
            const localVarFetchArgs = CommonClauseApiFetchParamCreator(configuration).commonClausePost(commonClauseInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ConfigApi - fetch parameter creator
 * @export
 */
export const ConfigApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 設定を取得します。
         * @summary 設定を取得
         * @throws {RequiredError}
         */
        configKeyGet(key: string, options: RequestOptions): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling configKeyGet.');
            }
            const localVarPath = `/config/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 設定を更新
         * @throws {RequiredError}
         */
        configPost(configInput: ConfigInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'configInput' is not null or undefined
            if (configInput === null || configInput === undefined) {
                throw new RequiredError('configInput','Required parameter configInput was null or undefined when calling configPost.');
            }
            const localVarPath = `/config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof configInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(configInput != null ? configInput : {}) : (((configInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ConfigApiType = { 
    configKeyGet(key: string, options?: RequestOptions): Promise<Object>,

    configPost(configInput: ConfigInput, options?: RequestOptions): Promise<Config>,
}

/**
 * ConfigApi - factory function to inject configuration 
 * @export
 */
export const ConfigApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ConfigApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 設定を取得します。
         * @summary 設定を取得
         * @throws {RequiredError}
         */
        configKeyGet(key: string, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = ConfigApiFetchParamCreator(configuration).configKeyGet(key, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 設定を更新
         * @throws {RequiredError}
         */
        configPost(configInput: ConfigInput, options?: RequestOptions = {}): Promise<Config> {
            const localVarFetchArgs = ConfigApiFetchParamCreator(configuration).configPost(configInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ContractApi - fetch parameter creator
 * @export
 */
export const ContractApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 契約一覧を取得
         * @throws {RequiredError}
         */
        contractGet(page?: number, pageSize?: number, sorter?: string, filters?: string, q?: string, dashboard?: boolean, options: RequestOptions): FetchArgs {
            const localVarPath = `/contract`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = ((q:any):string);
            }

            if (dashboard !== undefined) {
                localVarQueryParameter['dashboard'] = ((dashboard:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約情報削除
         * @throws {RequiredError}
         */
        contractIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractIdDelete.');
            }
            const localVarPath = `/contract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書ファイル更新
         * @throws {RequiredError}
         */
        contractIdFilePut(id: number, contractFileUpdate: ContractFileUpdate, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractIdFilePut.');
            }
            // verify required parameter 'contractFileUpdate' is not null or undefined
            if (contractFileUpdate === null || contractFileUpdate === undefined) {
                throw new RequiredError('contractFileUpdate','Required parameter contractFileUpdate was null or undefined when calling contractIdFilePut.');
            }
            const localVarPath = `/contract/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractFileUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractFileUpdate != null ? contractFileUpdate : {}) : (((contractFileUpdate:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約情報を取得
         * @throws {RequiredError}
         */
        contractIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractIdGet.');
            }
            const localVarPath = `/contract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約情報項目更新
         * @throws {RequiredError}
         */
        contractIdItemItemIdPut(id: number, itemId: number, contractFormValueUpdate: ContractFormValueUpdate, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractIdItemItemIdPut.');
            }
            // verify required parameter 'itemId' is not null or undefined
            if (itemId === null || itemId === undefined) {
                throw new RequiredError('itemId','Required parameter itemId was null or undefined when calling contractIdItemItemIdPut.');
            }
            // verify required parameter 'contractFormValueUpdate' is not null or undefined
            if (contractFormValueUpdate === null || contractFormValueUpdate === undefined) {
                throw new RequiredError('contractFormValueUpdate','Required parameter contractFormValueUpdate was null or undefined when calling contractIdItemItemIdPut.');
            }
            const localVarPath = `/contract/{id}/item/{itemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractFormValueUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractFormValueUpdate != null ? contractFormValueUpdate : {}) : (((contractFormValueUpdate:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約継続
         * @throws {RequiredError}
         */
        contractIdRenewalStatePut(id: number, contractRenewalStateInput: ContractRenewalStateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractIdRenewalStatePut.');
            }
            // verify required parameter 'contractRenewalStateInput' is not null or undefined
            if (contractRenewalStateInput === null || contractRenewalStateInput === undefined) {
                throw new RequiredError('contractRenewalStateInput','Required parameter contractRenewalStateInput was null or undefined when calling contractIdRenewalStatePut.');
            }
            const localVarPath = `/contract/{id}/renewalState`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRenewalStateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRenewalStateInput != null ? contractRenewalStateInput : {}) : (((contractRenewalStateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書数制限と登録数を取得
         * @throws {RequiredError}
         */
        contractLimitGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/contract/limit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約情報を登録
         * @throws {RequiredError}
         */
        contractPost(contractInput: ContractInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'contractInput' is not null or undefined
            if (contractInput === null || contractInput === undefined) {
                throw new RequiredError('contractInput','Required parameter contractInput was null or undefined when calling contractPost.');
            }
            const localVarPath = `/contract`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractInput != null ? contractInput : {}) : (((contractInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ContractApiType = { 
    contractGet(page?: number, pageSize?: number, sorter?: string, filters?: string, q?: string, dashboard?: boolean, options?: RequestOptions): Promise<ContractList>,

    contractIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    contractIdFilePut(id: number, contractFileUpdate: ContractFileUpdate, options?: RequestOptions): Promise<Contract>,

    contractIdGet(id: number, options?: RequestOptions): Promise<Contract>,

    contractIdItemItemIdPut(id: number, itemId: number, contractFormValueUpdate: ContractFormValueUpdate, options?: RequestOptions): Promise<Contract>,

    contractIdRenewalStatePut(id: number, contractRenewalStateInput: ContractRenewalStateInput, options?: RequestOptions): Promise<Contract>,

    contractLimitGet(options?: RequestOptions): Promise<ContractLimit>,

    contractPost(contractInput: ContractInput, options?: RequestOptions): Promise<Contract>,
}

/**
 * ContractApi - factory function to inject configuration 
 * @export
 */
export const ContractApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ContractApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 契約一覧を取得
         * @throws {RequiredError}
         */
        contractGet(page?: number, pageSize?: number, sorter?: string, filters?: string, q?: string, dashboard?: boolean, options?: RequestOptions = {}): Promise<ContractList> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractGet(page, pageSize, sorter, filters, q, dashboard, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約情報削除
         * @throws {RequiredError}
         */
        contractIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書ファイル更新
         * @throws {RequiredError}
         */
        contractIdFilePut(id: number, contractFileUpdate: ContractFileUpdate, options?: RequestOptions = {}): Promise<Contract> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractIdFilePut(id, contractFileUpdate, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約情報を取得
         * @throws {RequiredError}
         */
        contractIdGet(id: number, options?: RequestOptions = {}): Promise<Contract> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約情報項目更新
         * @throws {RequiredError}
         */
        contractIdItemItemIdPut(id: number, itemId: number, contractFormValueUpdate: ContractFormValueUpdate, options?: RequestOptions = {}): Promise<Contract> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractIdItemItemIdPut(id, itemId, contractFormValueUpdate, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約継続
         * @throws {RequiredError}
         */
        contractIdRenewalStatePut(id: number, contractRenewalStateInput: ContractRenewalStateInput, options?: RequestOptions = {}): Promise<Contract> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractIdRenewalStatePut(id, contractRenewalStateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書数制限と登録数を取得
         * @throws {RequiredError}
         */
        contractLimitGet(options?: RequestOptions = {}): Promise<ContractLimit> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractLimitGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約情報を登録
         * @throws {RequiredError}
         */
        contractPost(contractInput: ContractInput, options?: RequestOptions = {}): Promise<Contract> {
            const localVarFetchArgs = ContractApiFetchParamCreator(configuration).contractPost(contractInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ContractFormItemApi - fetch parameter creator
 * @export
 */
export const ContractFormItemApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 契約管理の機能で使用する項目の一覧を取得します
         * @summary 契約管理項目一覧を取得
         * @throws {RequiredError}
         */
        contractFormItemGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/contractFormItem`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約管理項目削除
         * @throws {RequiredError}
         */
        contractFormItemIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractFormItemIdDelete.');
            }
            const localVarPath = `/contractFormItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約管理項目を取得
         * @throws {RequiredError}
         */
        contractFormItemIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractFormItemIdGet.');
            }
            const localVarPath = `/contractFormItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約管理項目順序更新
         * @throws {RequiredError}
         */
        contractFormItemIdPositionPut(id: number, contractFormItemPositionInput: ContractFormItemPositionInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractFormItemIdPositionPut.');
            }
            // verify required parameter 'contractFormItemPositionInput' is not null or undefined
            if (contractFormItemPositionInput === null || contractFormItemPositionInput === undefined) {
                throw new RequiredError('contractFormItemPositionInput','Required parameter contractFormItemPositionInput was null or undefined when calling contractFormItemIdPositionPut.');
            }
            const localVarPath = `/contractFormItem/{id}/position`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractFormItemPositionInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractFormItemPositionInput != null ? contractFormItemPositionInput : {}) : (((contractFormItemPositionInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約管理項目更新
         * @throws {RequiredError}
         */
        contractFormItemIdPut(id: number, contractFormItemInput: ContractFormItemInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractFormItemIdPut.');
            }
            // verify required parameter 'contractFormItemInput' is not null or undefined
            if (contractFormItemInput === null || contractFormItemInput === undefined) {
                throw new RequiredError('contractFormItemInput','Required parameter contractFormItemInput was null or undefined when calling contractFormItemIdPut.');
            }
            const localVarPath = `/contractFormItem/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractFormItemInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractFormItemInput != null ? contractFormItemInput : {}) : (((contractFormItemInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約管理項目を登録
         * @throws {RequiredError}
         */
        contractFormItemPost(contractFormItemInput: ContractFormItemInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'contractFormItemInput' is not null or undefined
            if (contractFormItemInput === null || contractFormItemInput === undefined) {
                throw new RequiredError('contractFormItemInput','Required parameter contractFormItemInput was null or undefined when calling contractFormItemPost.');
            }
            const localVarPath = `/contractFormItem`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractFormItemInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractFormItemInput != null ? contractFormItemInput : {}) : (((contractFormItemInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ContractFormItemApiType = { 
    contractFormItemGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<ContractFormItemList>,

    contractFormItemIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    contractFormItemIdGet(id: number, options?: RequestOptions): Promise<ContractFormItem>,

    contractFormItemIdPositionPut(id: number, contractFormItemPositionInput: ContractFormItemPositionInput, options?: RequestOptions): Promise<ContractFormItem>,

    contractFormItemIdPut(id: number, contractFormItemInput: ContractFormItemInput, options?: RequestOptions): Promise<ContractFormItem>,

    contractFormItemPost(contractFormItemInput: ContractFormItemInput, options?: RequestOptions): Promise<ContractFormItem>,
}

/**
 * ContractFormItemApi - factory function to inject configuration 
 * @export
 */
export const ContractFormItemApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ContractFormItemApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 契約管理の機能で使用する項目の一覧を取得します
         * @summary 契約管理項目一覧を取得
         * @throws {RequiredError}
         */
        contractFormItemGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<ContractFormItemList> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約管理項目削除
         * @throws {RequiredError}
         */
        contractFormItemIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約管理項目を取得
         * @throws {RequiredError}
         */
        contractFormItemIdGet(id: number, options?: RequestOptions = {}): Promise<ContractFormItem> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約管理項目順序更新
         * @throws {RequiredError}
         */
        contractFormItemIdPositionPut(id: number, contractFormItemPositionInput: ContractFormItemPositionInput, options?: RequestOptions = {}): Promise<ContractFormItem> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemIdPositionPut(id, contractFormItemPositionInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約管理項目更新
         * @throws {RequiredError}
         */
        contractFormItemIdPut(id: number, contractFormItemInput: ContractFormItemInput, options?: RequestOptions = {}): Promise<ContractFormItem> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemIdPut(id, contractFormItemInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約管理項目を登録
         * @throws {RequiredError}
         */
        contractFormItemPost(contractFormItemInput: ContractFormItemInput, options?: RequestOptions = {}): Promise<ContractFormItem> {
            const localVarFetchArgs = ContractFormItemApiFetchParamCreator(configuration).contractFormItemPost(contractFormItemInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ContractNotificationApi - fetch parameter creator
 * @export
 */
export const ContractNotificationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 契約通知設定をすべて取得します。
         * @summary 契約通知設定一覧を取得
         * @throws {RequiredError}
         */
        contractNotificationGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/contractNotification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約通知設定を登録
         * @throws {RequiredError}
         */
        contractNotificationPost(contractNotificationInput: ContractNotificationInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'contractNotificationInput' is not null or undefined
            if (contractNotificationInput === null || contractNotificationInput === undefined) {
                throw new RequiredError('contractNotificationInput','Required parameter contractNotificationInput was null or undefined when calling contractNotificationPost.');
            }
            const localVarPath = `/contractNotification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractNotificationInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractNotificationInput != null ? contractNotificationInput : {}) : (((contractNotificationInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ContractNotificationApiType = { 
    contractNotificationGet(options?: RequestOptions): Promise<Array<ContractNotification>>,

    contractNotificationPost(contractNotificationInput: ContractNotificationInput, options?: RequestOptions): Promise<Array<ContractNotification>>,
}

/**
 * ContractNotificationApi - factory function to inject configuration 
 * @export
 */
export const ContractNotificationApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ContractNotificationApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 契約通知設定をすべて取得します。
         * @summary 契約通知設定一覧を取得
         * @throws {RequiredError}
         */
        contractNotificationGet(options?: RequestOptions = {}): Promise<Array<ContractNotification>> {
            const localVarFetchArgs = ContractNotificationApiFetchParamCreator(configuration).contractNotificationGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約通知設定を登録
         * @throws {RequiredError}
         */
        contractNotificationPost(contractNotificationInput: ContractNotificationInput, options?: RequestOptions = {}): Promise<Array<ContractNotification>> {
            const localVarFetchArgs = ContractNotificationApiFetchParamCreator(configuration).contractNotificationPost(contractNotificationInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * ContractRequestApi - fetch parameter creator
 * @export
 */
export const ContractRequestApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 契約書確認依頼のフォーム情報を取得
         * @throws {RequiredError}
         */
        contractRequestConfirmationFormGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/contractRequest/confirmationForm`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書削除
         * @throws {RequiredError}
         */
        contractRequestFileIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestFileIdDelete.');
            }
            const localVarPath = `/contractRequest/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼一覧を取得
         * @throws {RequiredError}
         */
        contractRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, selfOnly?: boolean, options: RequestOptions): FetchArgs {
            const localVarPath = `/contractRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            if (selfOnly !== undefined) {
                localVarQueryParameter['selfOnly'] = ((selfOnly:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼 コメント削除
         * @throws {RequiredError}
         */
        contractRequestIdCommentCommentIdDelete(id: number, commentId: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdCommentCommentIdDelete.');
            }
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) {
                throw new RequiredError('commentId','Required parameter commentId was null or undefined when calling contractRequestIdCommentCommentIdDelete.');
            }
            const localVarPath = `/contractRequest/{id}/comment/{commentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼 コメント編集
         * @throws {RequiredError}
         */
        contractRequestIdCommentCommentIdPut(id: number, commentId: number, contractRequestCommentUpdateInput: ContractRequestCommentUpdateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdCommentCommentIdPut.');
            }
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) {
                throw new RequiredError('commentId','Required parameter commentId was null or undefined when calling contractRequestIdCommentCommentIdPut.');
            }
            // verify required parameter 'contractRequestCommentUpdateInput' is not null or undefined
            if (contractRequestCommentUpdateInput === null || contractRequestCommentUpdateInput === undefined) {
                throw new RequiredError('contractRequestCommentUpdateInput','Required parameter contractRequestCommentUpdateInput was null or undefined when calling contractRequestIdCommentCommentIdPut.');
            }
            const localVarPath = `/contractRequest/{id}/comment/{commentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestCommentUpdateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestCommentUpdateInput != null ? contractRequestCommentUpdateInput : {}) : (((contractRequestCommentUpdateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コメント追加
         * @throws {RequiredError}
         */
        contractRequestIdCommentPost(id: number, contractRequestCommentCreateInput: ContractRequestCommentCreateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdCommentPost.');
            }
            // verify required parameter 'contractRequestCommentCreateInput' is not null or undefined
            if (contractRequestCommentCreateInput === null || contractRequestCommentCreateInput === undefined) {
                throw new RequiredError('contractRequestCommentCreateInput','Required parameter contractRequestCommentCreateInput was null or undefined when calling contractRequestIdCommentPost.');
            }
            const localVarPath = `/contractRequest/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestCommentCreateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestCommentCreateInput != null ? contractRequestCommentCreateInput : {}) : (((contractRequestCommentCreateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼削除
         * @throws {RequiredError}
         */
        contractRequestIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdDelete.');
            }
            const localVarPath = `/contractRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼情報を取得
         * @throws {RequiredError}
         */
        contractRequestIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdGet.');
            }
            const localVarPath = `/contractRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼を更新(下書きの場合のみ)
         * @throws {RequiredError}
         */
        contractRequestIdPut(id: number, contractRequestInput: ContractRequestInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdPut.');
            }
            // verify required parameter 'contractRequestInput' is not null or undefined
            if (contractRequestInput === null || contractRequestInput === undefined) {
                throw new RequiredError('contractRequestInput','Required parameter contractRequestInput was null or undefined when calling contractRequestIdPut.');
            }
            const localVarPath = `/contractRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestInput != null ? contractRequestInput : {}) : (((contractRequestInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼 再開する
         * @throws {RequiredError}
         */
        contractRequestIdResumePut(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdResumePut.');
            }
            const localVarPath = `/contractRequest/{id}/resume`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ステータスを更新
         * @throws {RequiredError}
         */
        contractRequestIdStatePut(id: number, contractRequestStateInput: ContractRequestStateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdStatePut.');
            }
            // verify required parameter 'contractRequestStateInput' is not null or undefined
            if (contractRequestStateInput === null || contractRequestStateInput === undefined) {
                throw new RequiredError('contractRequestStateInput','Required parameter contractRequestStateInput was null or undefined when calling contractRequestIdStatePut.');
            }
            const localVarPath = `/contractRequest/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestStateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestStateInput != null ? contractRequestStateInput : {}) : (((contractRequestStateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼 保留にする
         * @throws {RequiredError}
         */
        contractRequestIdSuspendPut(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestIdSuspendPut.');
            }
            const localVarPath = `/contractRequest/{id}/suspend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パラメータの値を更新する
         * @throws {RequiredError}
         */
        contractRequestParameterIdValuePut(id: number, contractRequestParameterUpdateInput: ContractRequestParameterUpdateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contractRequestParameterIdValuePut.');
            }
            // verify required parameter 'contractRequestParameterUpdateInput' is not null or undefined
            if (contractRequestParameterUpdateInput === null || contractRequestParameterUpdateInput === undefined) {
                throw new RequiredError('contractRequestParameterUpdateInput','Required parameter contractRequestParameterUpdateInput was null or undefined when calling contractRequestParameterIdValuePut.');
            }
            const localVarPath = `/contractRequest/parameter/{id}/value`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestParameterUpdateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestParameterUpdateInput != null ? contractRequestParameterUpdateInput : {}) : (((contractRequestParameterUpdateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼作成
         * @throws {RequiredError}
         */
        contractRequestPost(contractRequestInput: ContractRequestInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'contractRequestInput' is not null or undefined
            if (contractRequestInput === null || contractRequestInput === undefined) {
                throw new RequiredError('contractRequestInput','Required parameter contractRequestInput was null or undefined when calling contractRequestPost.');
            }
            const localVarPath = `/contractRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof contractRequestInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(contractRequestInput != null ? contractRequestInput : {}) : (((contractRequestInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type ContractRequestApiType = { 
    contractRequestConfirmationFormGet(options?: RequestOptions): Promise<Array<Variable>>,

    contractRequestFileIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    contractRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, selfOnly?: boolean, options?: RequestOptions): Promise<ContractRequestList>,

    contractRequestIdCommentCommentIdDelete(id: number, commentId: number, options?: RequestOptions): Promise<DeleteResult>,

    contractRequestIdCommentCommentIdPut(id: number, commentId: number, contractRequestCommentUpdateInput: ContractRequestCommentUpdateInput, options?: RequestOptions): Promise<ContractRequestComment>,

    contractRequestIdCommentPost(id: number, contractRequestCommentCreateInput: ContractRequestCommentCreateInput, options?: RequestOptions): Promise<ContractRequestComment>,

    contractRequestIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    contractRequestIdGet(id: number, options?: RequestOptions): Promise<ContractRequest>,

    contractRequestIdPut(id: number, contractRequestInput: ContractRequestInput, options?: RequestOptions): Promise<ContractRequest>,

    contractRequestIdResumePut(id: number, options?: RequestOptions): Promise<ContractRequest>,

    contractRequestIdStatePut(id: number, contractRequestStateInput: ContractRequestStateInput, options?: RequestOptions): Promise<ContractRequestParameter>,

    contractRequestIdSuspendPut(id: number, options?: RequestOptions): Promise<ContractRequest>,

    contractRequestParameterIdValuePut(id: number, contractRequestParameterUpdateInput: ContractRequestParameterUpdateInput, options?: RequestOptions): Promise<ContractRequestParameter>,

    contractRequestPost(contractRequestInput: ContractRequestInput, options?: RequestOptions): Promise<ContractRequest>,
}

/**
 * ContractRequestApi - factory function to inject configuration 
 * @export
 */
export const ContractRequestApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): ContractRequestApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 契約書確認依頼のフォーム情報を取得
         * @throws {RequiredError}
         */
        contractRequestConfirmationFormGet(options?: RequestOptions = {}): Promise<Array<Variable>> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestConfirmationFormGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書削除
         * @throws {RequiredError}
         */
        contractRequestFileIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestFileIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼一覧を取得
         * @throws {RequiredError}
         */
        contractRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, selfOnly?: boolean, options?: RequestOptions = {}): Promise<ContractRequestList> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestGet(page, pageSize, sorter, filters, selfOnly, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼 コメント削除
         * @throws {RequiredError}
         */
        contractRequestIdCommentCommentIdDelete(id: number, commentId: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdCommentCommentIdDelete(id, commentId, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼 コメント編集
         * @throws {RequiredError}
         */
        contractRequestIdCommentCommentIdPut(id: number, commentId: number, contractRequestCommentUpdateInput: ContractRequestCommentUpdateInput, options?: RequestOptions = {}): Promise<ContractRequestComment> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdCommentCommentIdPut(id, commentId, contractRequestCommentUpdateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary コメント追加
         * @throws {RequiredError}
         */
        contractRequestIdCommentPost(id: number, contractRequestCommentCreateInput: ContractRequestCommentCreateInput, options?: RequestOptions = {}): Promise<ContractRequestComment> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdCommentPost(id, contractRequestCommentCreateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼削除
         * @throws {RequiredError}
         */
        contractRequestIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼情報を取得
         * @throws {RequiredError}
         */
        contractRequestIdGet(id: number, options?: RequestOptions = {}): Promise<ContractRequest> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼を更新(下書きの場合のみ)
         * @throws {RequiredError}
         */
        contractRequestIdPut(id: number, contractRequestInput: ContractRequestInput, options?: RequestOptions = {}): Promise<ContractRequest> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdPut(id, contractRequestInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼 再開する
         * @throws {RequiredError}
         */
        contractRequestIdResumePut(id: number, options?: RequestOptions = {}): Promise<ContractRequest> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdResumePut(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ステータスを更新
         * @throws {RequiredError}
         */
        contractRequestIdStatePut(id: number, contractRequestStateInput: ContractRequestStateInput, options?: RequestOptions = {}): Promise<ContractRequestParameter> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdStatePut(id, contractRequestStateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼 保留にする
         * @throws {RequiredError}
         */
        contractRequestIdSuspendPut(id: number, options?: RequestOptions = {}): Promise<ContractRequest> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestIdSuspendPut(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary パラメータの値を更新する
         * @throws {RequiredError}
         */
        contractRequestParameterIdValuePut(id: number, contractRequestParameterUpdateInput: ContractRequestParameterUpdateInput, options?: RequestOptions = {}): Promise<ContractRequestParameter> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestParameterIdValuePut(id, contractRequestParameterUpdateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼作成
         * @throws {RequiredError}
         */
        contractRequestPost(contractRequestInput: ContractRequestInput, options?: RequestOptions = {}): Promise<ContractRequest> {
            const localVarFetchArgs = ContractRequestApiFetchParamCreator(configuration).contractRequestPost(contractRequestInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * CorporationApi - fetch parameter creator
 * @export
 */
export const CorporationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 企業一覧を取得
         * @throws {RequiredError}
         */
        corporationGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/corporation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 企業情報削除
         * @throws {RequiredError}
         */
        corporationIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling corporationIdDelete.');
            }
            const localVarPath = `/corporation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 企業情報を取得
         * @throws {RequiredError}
         */
        corporationIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling corporationIdGet.');
            }
            const localVarPath = `/corporation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * IDを指定して企業情報を編集します
         * @summary 企業情報を編集
         * @throws {RequiredError}
         */
        corporationIdPut(id: number, corporationInput: CorporationInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling corporationIdPut.');
            }
            // verify required parameter 'corporationInput' is not null or undefined
            if (corporationInput === null || corporationInput === undefined) {
                throw new RequiredError('corporationInput','Required parameter corporationInput was null or undefined when calling corporationIdPut.');
            }
            const localVarPath = `/corporation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof corporationInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(corporationInput != null ? corporationInput : {}) : (((corporationInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 企業情報を新規登録
         * @throws {RequiredError}
         */
        corporationPost(corporationInput: CorporationInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'corporationInput' is not null or undefined
            if (corporationInput === null || corporationInput === undefined) {
                throw new RequiredError('corporationInput','Required parameter corporationInput was null or undefined when calling corporationPost.');
            }
            const localVarPath = `/corporation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof corporationInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(corporationInput != null ? corporationInput : {}) : (((corporationInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type CorporationApiType = { 
    corporationGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<CorporationList>,

    corporationIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    corporationIdGet(id: number, options?: RequestOptions): Promise<CorporationDetail>,

    corporationIdPut(id: number, corporationInput: CorporationInput, options?: RequestOptions): Promise<Corporation>,

    corporationPost(corporationInput: CorporationInput, options?: RequestOptions): Promise<Corporation>,
}

/**
 * CorporationApi - factory function to inject configuration 
 * @export
 */
export const CorporationApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): CorporationApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 企業一覧を取得
         * @throws {RequiredError}
         */
        corporationGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<CorporationList> {
            const localVarFetchArgs = CorporationApiFetchParamCreator(configuration).corporationGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 企業情報削除
         * @throws {RequiredError}
         */
        corporationIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = CorporationApiFetchParamCreator(configuration).corporationIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 企業情報を取得
         * @throws {RequiredError}
         */
        corporationIdGet(id: number, options?: RequestOptions = {}): Promise<CorporationDetail> {
            const localVarFetchArgs = CorporationApiFetchParamCreator(configuration).corporationIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * IDを指定して企業情報を編集します
         * @summary 企業情報を編集
         * @throws {RequiredError}
         */
        corporationIdPut(id: number, corporationInput: CorporationInput, options?: RequestOptions = {}): Promise<Corporation> {
            const localVarFetchArgs = CorporationApiFetchParamCreator(configuration).corporationIdPut(id, corporationInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 企業情報を新規登録
         * @throws {RequiredError}
         */
        corporationPost(corporationInput: CorporationInput, options?: RequestOptions = {}): Promise<Corporation> {
            const localVarFetchArgs = CorporationApiFetchParamCreator(configuration).corporationPost(corporationInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * FileApi - fetch parameter creator
 * @export
 */
export const FileApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ファイルをS3とデータベースから削除します
         * @summary ファイルを削除
         * @throws {RequiredError}
         */
        fileIdNameDelete(id: number, name: string, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fileIdNameDelete.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling fileIdNameDelete.');
            }
            const localVarPath = `/file/{id}/{name}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WordファイルをPDFに変換して返します
         * @summary プレビューを取得
         * @throws {RequiredError}
         */
        filePreviewPost(filePreviewInput: FilePreviewInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'filePreviewInput' is not null or undefined
            if (filePreviewInput === null || filePreviewInput === undefined) {
                throw new RequiredError('filePreviewInput','Required parameter filePreviewInput was null or undefined when calling filePreviewPost.');
            }
            const localVarPath = `/file/preview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof filePreviewInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(filePreviewInput != null ? filePreviewInput : {}) : (((filePreviewInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type FileApiType = { 
    fileIdNameDelete(id: number, name: string, options?: RequestOptions): Promise<DeleteResult>,

    filePreviewPost(filePreviewInput: FilePreviewInput, options?: RequestOptions): Promise<FilePreview>,
}

/**
 * FileApi - factory function to inject configuration 
 * @export
 */
export const FileApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): FileApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * ファイルをS3とデータベースから削除します
         * @summary ファイルを削除
         * @throws {RequiredError}
         */
        fileIdNameDelete(id: number, name: string, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = FileApiFetchParamCreator(configuration).fileIdNameDelete(id, name, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * WordファイルをPDFに変換して返します
         * @summary プレビューを取得
         * @throws {RequiredError}
         */
        filePreviewPost(filePreviewInput: FilePreviewInput, options?: RequestOptions = {}): Promise<FilePreview> {
            const localVarFetchArgs = FileApiFetchParamCreator(configuration).filePreviewPost(filePreviewInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * GroupApi - fetch parameter creator
 * @export
 */
export const GroupApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 部署一覧を取得
         * @throws {RequiredError}
         */
        groupGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署削除
         * @throws {RequiredError}
         */
        groupIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling groupIdDelete.');
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署を取得
         * @throws {RequiredError}
         */
        groupIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling groupIdGet.');
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署順序更新
         * @throws {RequiredError}
         */
        groupIdPositionPut(id: number, groupPositionInput: GroupPositionInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling groupIdPositionPut.');
            }
            // verify required parameter 'groupPositionInput' is not null or undefined
            if (groupPositionInput === null || groupPositionInput === undefined) {
                throw new RequiredError('groupPositionInput','Required parameter groupPositionInput was null or undefined when calling groupIdPositionPut.');
            }
            const localVarPath = `/group/{id}/position`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof groupPositionInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(groupPositionInput != null ? groupPositionInput : {}) : (((groupPositionInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署更新
         * @throws {RequiredError}
         */
        groupIdPut(id: number, groupInput: GroupInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling groupIdPut.');
            }
            // verify required parameter 'groupInput' is not null or undefined
            if (groupInput === null || groupInput === undefined) {
                throw new RequiredError('groupInput','Required parameter groupInput was null or undefined when calling groupIdPut.');
            }
            const localVarPath = `/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof groupInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(groupInput != null ? groupInput : {}) : (((groupInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署を登録
         * @throws {RequiredError}
         */
        groupPost(groupInput: GroupInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'groupInput' is not null or undefined
            if (groupInput === null || groupInput === undefined) {
                throw new RequiredError('groupInput','Required parameter groupInput was null or undefined when calling groupPost.');
            }
            const localVarPath = `/group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof groupInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(groupInput != null ? groupInput : {}) : (((groupInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type GroupApiType = { 
    groupGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<GroupList>,

    groupIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    groupIdGet(id: number, options?: RequestOptions): Promise<Group>,

    groupIdPositionPut(id: number, groupPositionInput: GroupPositionInput, options?: RequestOptions): Promise<Group>,

    groupIdPut(id: number, groupInput: GroupInput, options?: RequestOptions): Promise<Group>,

    groupPost(groupInput: GroupInput, options?: RequestOptions): Promise<Group>,
}

/**
 * GroupApi - factory function to inject configuration 
 * @export
 */
export const GroupApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): GroupApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 部署一覧を取得
         * @throws {RequiredError}
         */
        groupGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<GroupList> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 部署削除
         * @throws {RequiredError}
         */
        groupIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 部署を取得
         * @throws {RequiredError}
         */
        groupIdGet(id: number, options?: RequestOptions = {}): Promise<Group> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 部署順序更新
         * @throws {RequiredError}
         */
        groupIdPositionPut(id: number, groupPositionInput: GroupPositionInput, options?: RequestOptions = {}): Promise<Group> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupIdPositionPut(id, groupPositionInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 部署更新
         * @throws {RequiredError}
         */
        groupIdPut(id: number, groupInput: GroupInput, options?: RequestOptions = {}): Promise<Group> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupIdPut(id, groupInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 部署を登録
         * @throws {RequiredError}
         */
        groupPost(groupInput: GroupInput, options?: RequestOptions = {}): Promise<Group> {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupPost(groupInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * IPApi - fetch parameter creator
 * @export
 */
export const IPApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 許可IP一覧を取得
         * @throws {RequiredError}
         */
        ipAllowedGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/ip/allowed`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 許可IPを登録
         * @throws {RequiredError}
         */
        ipAllowedPost(allowedIpInput: Array<AllowedIpInput>, options: RequestOptions): FetchArgs {
            // verify required parameter 'allowedIpInput' is not null or undefined
            if (allowedIpInput === null || allowedIpInput === undefined) {
                throw new RequiredError('allowedIpInput','Required parameter allowedIpInput was null or undefined when calling ipAllowedPost.');
            }
            const localVarPath = `/ip/allowed`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof allowedIpInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(allowedIpInput != null ? allowedIpInput : {}) : (((allowedIpInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 接続元IPアドレスを取得
         * @throws {RequiredError}
         */
        ipCurrentGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/ip/current`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type IPApiType = { 
    ipAllowedGet(options?: RequestOptions): Promise<Array<AllowedIp>>,

    ipAllowedPost(allowedIpInput: Array<AllowedIpInput>, options?: RequestOptions): Promise<Array<AllowedIp>>,

    ipCurrentGet(options?: RequestOptions): Promise<CurrentIpOutput>,
}

/**
 * IPApi - factory function to inject configuration 
 * @export
 */
export const IPApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): IPApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 許可IP一覧を取得
         * @throws {RequiredError}
         */
        ipAllowedGet(options?: RequestOptions = {}): Promise<Array<AllowedIp>> {
            const localVarFetchArgs = IPApiFetchParamCreator(configuration).ipAllowedGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 許可IPを登録
         * @throws {RequiredError}
         */
        ipAllowedPost(allowedIpInput: Array<AllowedIpInput>, options?: RequestOptions = {}): Promise<Array<AllowedIp>> {
            const localVarFetchArgs = IPApiFetchParamCreator(configuration).ipAllowedPost(allowedIpInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 接続元IPアドレスを取得
         * @throws {RequiredError}
         */
        ipCurrentGet(options?: RequestOptions = {}): Promise<CurrentIpOutput> {
            const localVarFetchArgs = IPApiFetchParamCreator(configuration).ipCurrentGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * NotificationApi - fetch parameter creator
 * @export
 */
export const NotificationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 通知一覧を取得
         * @throws {RequiredError}
         */
        notificationGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/notification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 通知を削除
         * @throws {RequiredError}
         */
        notificationIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling notificationIdDelete.');
            }
            const localVarPath = `/notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type NotificationApiType = { 
    notificationGet(options?: RequestOptions): Promise<Array<Notification>>,

    notificationIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,
}

/**
 * NotificationApi - factory function to inject configuration 
 * @export
 */
export const NotificationApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): NotificationApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 通知一覧を取得
         * @throws {RequiredError}
         */
        notificationGet(options?: RequestOptions = {}): Promise<Array<Notification>> {
            const localVarFetchArgs = NotificationApiFetchParamCreator(configuration).notificationGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 通知を削除
         * @throws {RequiredError}
         */
        notificationIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = NotificationApiFetchParamCreator(configuration).notificationIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * OperationLogApi - fetch parameter creator
 * @export
 */
export const OperationLogApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 操作ログ一覧を取得
         * @throws {RequiredError}
         */
        operationLogCategoryGet(category: string, page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling operationLogCategoryGet.');
            }
            const localVarPath = `/operationLog/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type OperationLogApiType = { 
    operationLogCategoryGet(category: string, page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<OperationLogList>,
}

/**
 * OperationLogApi - factory function to inject configuration 
 * @export
 */
export const OperationLogApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): OperationLogApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 操作ログ一覧を取得
         * @throws {RequiredError}
         */
        operationLogCategoryGet(category: string, page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<OperationLogList> {
            const localVarFetchArgs = OperationLogApiFetchParamCreator(configuration).operationLogCategoryGet(category, page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * RoleApi - fetch parameter creator
 * @export
 */
export const RoleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 権限一覧を取得
         * @throws {RequiredError}
         */
        roleGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/role`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限削除
         * @throws {RequiredError}
         */
        roleIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling roleIdDelete.');
            }
            const localVarPath = `/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限を取得
         * @throws {RequiredError}
         */
        roleIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling roleIdGet.');
            }
            const localVarPath = `/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限更新
         * @throws {RequiredError}
         */
        roleIdPut(id: number, roleInput: RoleInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling roleIdPut.');
            }
            // verify required parameter 'roleInput' is not null or undefined
            if (roleInput === null || roleInput === undefined) {
                throw new RequiredError('roleInput','Required parameter roleInput was null or undefined when calling roleIdPut.');
            }
            const localVarPath = `/role/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof roleInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(roleInput != null ? roleInput : {}) : (((roleInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限を登録
         * @throws {RequiredError}
         */
        rolePost(roleInput: RoleInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'roleInput' is not null or undefined
            if (roleInput === null || roleInput === undefined) {
                throw new RequiredError('roleInput','Required parameter roleInput was null or undefined when calling rolePost.');
            }
            const localVarPath = `/role`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof roleInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(roleInput != null ? roleInput : {}) : (((roleInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type RoleApiType = { 
    roleGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<RoleList>,

    roleIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    roleIdGet(id: number, options?: RequestOptions): Promise<Role>,

    roleIdPut(id: number, roleInput: RoleInput, options?: RequestOptions): Promise<Role>,

    rolePost(roleInput: RoleInput, options?: RequestOptions): Promise<Role>,
}

/**
 * RoleApi - factory function to inject configuration 
 * @export
 */
export const RoleApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): RoleApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 権限一覧を取得
         * @throws {RequiredError}
         */
        roleGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<RoleList> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 権限削除
         * @throws {RequiredError}
         */
        roleIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 権限を取得
         * @throws {RequiredError}
         */
        roleIdGet(id: number, options?: RequestOptions = {}): Promise<Role> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 権限更新
         * @throws {RequiredError}
         */
        roleIdPut(id: number, roleInput: RoleInput, options?: RequestOptions = {}): Promise<Role> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).roleIdPut(id, roleInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 権限を登録
         * @throws {RequiredError}
         */
        rolePost(roleInput: RoleInput, options?: RequestOptions = {}): Promise<Role> {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).rolePost(roleInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * SignupApi - fetch parameter creator
 * @export
 */
export const SignupApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 登録をキャンセルする
         * @throws {RequiredError}
         */
        signupCancelPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/signup/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客情報が登録済みかどうかチェックする
         * @throws {RequiredError}
         */
        signupCheckCustomerPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/signup/checkCustomer`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客情報を取得
         * @throws {RequiredError}
         */
        signupCustomerGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/signup/customer`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織情報登録
         * @throws {RequiredError}
         */
        signupOrganizationPost(inputSignupOrganization: InputSignupOrganization, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputSignupOrganization' is not null or undefined
            if (inputSignupOrganization === null || inputSignupOrganization === undefined) {
                throw new RequiredError('inputSignupOrganization','Required parameter inputSignupOrganization was null or undefined when calling signupOrganizationPost.');
            }
            const localVarPath = `/signup/organization`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputSignupOrganization !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputSignupOrganization != null ? inputSignupOrganization : {}) : (((inputSignupOrganization:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客情報に紐づいているライセンスキーを解放する
         * @throws {RequiredError}
         */
        signupReleaseLicenseKeyPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/signup/releaseLicenseKey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 仮パスワードを再送する
         * @throws {RequiredError}
         */
        signupResendPasswordPost(inputSignupResendPassword: InputSignupResendPassword, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputSignupResendPassword' is not null or undefined
            if (inputSignupResendPassword === null || inputSignupResendPassword === undefined) {
                throw new RequiredError('inputSignupResendPassword','Required parameter inputSignupResendPassword was null or undefined when calling signupResendPasswordPost.');
            }
            const localVarPath = `/signup/resendPassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputSignupResendPassword !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputSignupResendPassword != null ? inputSignupResendPassword : {}) : (((inputSignupResendPassword:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ライセンスキーを顧客情報に紐づける
         * @throws {RequiredError}
         */
        signupReserveLicenseKeyPost(inputSignupReserveLicenseKey: InputSignupReserveLicenseKey, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputSignupReserveLicenseKey' is not null or undefined
            if (inputSignupReserveLicenseKey === null || inputSignupReserveLicenseKey === undefined) {
                throw new RequiredError('inputSignupReserveLicenseKey','Required parameter inputSignupReserveLicenseKey was null or undefined when calling signupReserveLicenseKeyPost.');
            }
            const localVarPath = `/signup/reserveLicenseKey`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputSignupReserveLicenseKey !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputSignupReserveLicenseKey != null ? inputSignupReserveLicenseKey : {}) : (((inputSignupReserveLicenseKey:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 顧客用の環境をセットアップする
         * @throws {RequiredError}
         */
        signupSetupPost(inputSignupSetup: InputSignupSetup, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputSignupSetup' is not null or undefined
            if (inputSignupSetup === null || inputSignupSetup === undefined) {
                throw new RequiredError('inputSignupSetup','Required parameter inputSignupSetup was null or undefined when calling signupSetupPost.');
            }
            const localVarPath = `/signup/setup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputSignupSetup !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputSignupSetup != null ? inputSignupSetup : {}) : (((inputSignupSetup:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stripeセッションを取得
         * @throws {RequiredError}
         */
        signupStripeSessionPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/signup/stripeSession`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type SignupApiType = { 
    signupCancelPost(options?: RequestOptions): Promise<Object>,

    signupCheckCustomerPost(options?: RequestOptions): Promise<OutputCheckCustomer>,

    signupCustomerGet(options?: RequestOptions): Promise<Customer>,

    signupOrganizationPost(inputSignupOrganization: InputSignupOrganization, options?: RequestOptions): Promise<OutputSignupOrganization>,

    signupReleaseLicenseKeyPost(options?: RequestOptions): Promise<Object>,

    signupResendPasswordPost(inputSignupResendPassword: InputSignupResendPassword, options?: RequestOptions): Promise<Object>,

    signupReserveLicenseKeyPost(inputSignupReserveLicenseKey: InputSignupReserveLicenseKey, options?: RequestOptions): Promise<OutputSignupReserveLicenseKey>,

    signupSetupPost(inputSignupSetup: InputSignupSetup, options?: RequestOptions): Promise<Object>,

    signupStripeSessionPost(options?: RequestOptions): Promise<OutputStripeSession>,
}

/**
 * SignupApi - factory function to inject configuration 
 * @export
 */
export const SignupApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): SignupApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 登録をキャンセルする
         * @throws {RequiredError}
         */
        signupCancelPost(options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupCancelPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 顧客情報が登録済みかどうかチェックする
         * @throws {RequiredError}
         */
        signupCheckCustomerPost(options?: RequestOptions = {}): Promise<OutputCheckCustomer> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupCheckCustomerPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 顧客情報を取得
         * @throws {RequiredError}
         */
        signupCustomerGet(options?: RequestOptions = {}): Promise<Customer> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupCustomerGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 組織情報登録
         * @throws {RequiredError}
         */
        signupOrganizationPost(inputSignupOrganization: InputSignupOrganization, options?: RequestOptions = {}): Promise<OutputSignupOrganization> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupOrganizationPost(inputSignupOrganization, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 顧客情報に紐づいているライセンスキーを解放する
         * @throws {RequiredError}
         */
        signupReleaseLicenseKeyPost(options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupReleaseLicenseKeyPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 仮パスワードを再送する
         * @throws {RequiredError}
         */
        signupResendPasswordPost(inputSignupResendPassword: InputSignupResendPassword, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupResendPasswordPost(inputSignupResendPassword, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ライセンスキーを顧客情報に紐づける
         * @throws {RequiredError}
         */
        signupReserveLicenseKeyPost(inputSignupReserveLicenseKey: InputSignupReserveLicenseKey, options?: RequestOptions = {}): Promise<OutputSignupReserveLicenseKey> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupReserveLicenseKeyPost(inputSignupReserveLicenseKey, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 顧客用の環境をセットアップする
         * @throws {RequiredError}
         */
        signupSetupPost(inputSignupSetup: InputSignupSetup, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupSetupPost(inputSignupSetup, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary Stripeセッションを取得
         * @throws {RequiredError}
         */
        signupStripeSessionPost(options?: RequestOptions = {}): Promise<OutputStripeSession> {
            const localVarFetchArgs = SignupApiFetchParamCreator(configuration).signupStripeSessionPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * StampApprovalRouteApi - fetch parameter creator
 * @export
 */
export const StampApprovalRouteApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 押捺承認経路一覧を取得
         * @throws {RequiredError}
         */
        stampApprovalRouteGet(page?: number, pageSize?: number, sorter?: string, filters?: string, includeDeleted?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/stampApprovalRoute`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = ((includeDeleted:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺承認経路削除
         * @throws {RequiredError}
         */
        stampApprovalRouteIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampApprovalRouteIdDelete.');
            }
            const localVarPath = `/stampApprovalRoute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請経路情報を取得
         * @throws {RequiredError}
         */
        stampApprovalRouteIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampApprovalRouteIdGet.');
            }
            const localVarPath = `/stampApprovalRoute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺承認経路更新
         * @throws {RequiredError}
         */
        stampApprovalRouteIdPut(id: number, stampApprovalRouteInput: StampApprovalRouteInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampApprovalRouteIdPut.');
            }
            // verify required parameter 'stampApprovalRouteInput' is not null or undefined
            if (stampApprovalRouteInput === null || stampApprovalRouteInput === undefined) {
                throw new RequiredError('stampApprovalRouteInput','Required parameter stampApprovalRouteInput was null or undefined when calling stampApprovalRouteIdPut.');
            }
            const localVarPath = `/stampApprovalRoute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampApprovalRouteInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampApprovalRouteInput != null ? stampApprovalRouteInput : {}) : (((stampApprovalRouteInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通条項新規作成
         * @throws {RequiredError}
         */
        stampApprovalRoutePost(stampApprovalRouteInput: StampApprovalRouteInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'stampApprovalRouteInput' is not null or undefined
            if (stampApprovalRouteInput === null || stampApprovalRouteInput === undefined) {
                throw new RequiredError('stampApprovalRouteInput','Required parameter stampApprovalRouteInput was null or undefined when calling stampApprovalRoutePost.');
            }
            const localVarPath = `/stampApprovalRoute`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampApprovalRouteInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampApprovalRouteInput != null ? stampApprovalRouteInput : {}) : (((stampApprovalRouteInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type StampApprovalRouteApiType = { 
    stampApprovalRouteGet(page?: number, pageSize?: number, sorter?: string, filters?: string, includeDeleted?: string, options?: RequestOptions): Promise<StampApprovalRouteList>,

    stampApprovalRouteIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    stampApprovalRouteIdGet(id: number, options?: RequestOptions): Promise<StampApprovalRoute>,

    stampApprovalRouteIdPut(id: number, stampApprovalRouteInput: StampApprovalRouteInput, options?: RequestOptions): Promise<StampApprovalRoute>,

    stampApprovalRoutePost(stampApprovalRouteInput: StampApprovalRouteInput, options?: RequestOptions): Promise<StampApprovalRoute>,
}

/**
 * StampApprovalRouteApi - factory function to inject configuration 
 * @export
 */
export const StampApprovalRouteApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): StampApprovalRouteApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 押捺承認経路一覧を取得
         * @throws {RequiredError}
         */
        stampApprovalRouteGet(page?: number, pageSize?: number, sorter?: string, filters?: string, includeDeleted?: string, options?: RequestOptions = {}): Promise<StampApprovalRouteList> {
            const localVarFetchArgs = StampApprovalRouteApiFetchParamCreator(configuration).stampApprovalRouteGet(page, pageSize, sorter, filters, includeDeleted, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺承認経路削除
         * @throws {RequiredError}
         */
        stampApprovalRouteIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = StampApprovalRouteApiFetchParamCreator(configuration).stampApprovalRouteIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請経路情報を取得
         * @throws {RequiredError}
         */
        stampApprovalRouteIdGet(id: number, options?: RequestOptions = {}): Promise<StampApprovalRoute> {
            const localVarFetchArgs = StampApprovalRouteApiFetchParamCreator(configuration).stampApprovalRouteIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺承認経路更新
         * @throws {RequiredError}
         */
        stampApprovalRouteIdPut(id: number, stampApprovalRouteInput: StampApprovalRouteInput, options?: RequestOptions = {}): Promise<StampApprovalRoute> {
            const localVarFetchArgs = StampApprovalRouteApiFetchParamCreator(configuration).stampApprovalRouteIdPut(id, stampApprovalRouteInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通条項新規作成
         * @throws {RequiredError}
         */
        stampApprovalRoutePost(stampApprovalRouteInput: StampApprovalRouteInput, options?: RequestOptions = {}): Promise<StampApprovalRoute> {
            const localVarFetchArgs = StampApprovalRouteApiFetchParamCreator(configuration).stampApprovalRoutePost(stampApprovalRouteInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * StampRequestApi - fetch parameter creator
 * @export
 */
export const StampRequestApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 押捺申請一覧を取得
         * @throws {RequiredError}
         */
        stampRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, userId?: number, options: RequestOptions): FetchArgs {
            const localVarPath = `/stampRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = ((userId:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請 承認
         * @throws {RequiredError}
         */
        stampRequestIdApprovePut(id: number, stampRequestApproveInput: StampRequestApproveInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdApprovePut.');
            }
            // verify required parameter 'stampRequestApproveInput' is not null or undefined
            if (stampRequestApproveInput === null || stampRequestApproveInput === undefined) {
                throw new RequiredError('stampRequestApproveInput','Required parameter stampRequestApproveInput was null or undefined when calling stampRequestIdApprovePut.');
            }
            const localVarPath = `/stampRequest/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampRequestApproveInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampRequestApproveInput != null ? stampRequestApproveInput : {}) : (((stampRequestApproveInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請削除
         * @throws {RequiredError}
         */
        stampRequestIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdDelete.');
            }
            const localVarPath = `/stampRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請 承認/差し戻し内容の修正
         * @throws {RequiredError}
         */
        stampRequestIdEditPut(id: number, stampRequestEditInput: StampRequestEditInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdEditPut.');
            }
            // verify required parameter 'stampRequestEditInput' is not null or undefined
            if (stampRequestEditInput === null || stampRequestEditInput === undefined) {
                throw new RequiredError('stampRequestEditInput','Required parameter stampRequestEditInput was null or undefined when calling stampRequestIdEditPut.');
            }
            const localVarPath = `/stampRequest/{id}/edit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampRequestEditInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampRequestEditInput != null ? stampRequestEditInput : {}) : (((stampRequestEditInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請情報を取得
         * @throws {RequiredError}
         */
        stampRequestIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdGet.');
            }
            const localVarPath = `/stampRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請 再申請/下書き更新
         * @throws {RequiredError}
         */
        stampRequestIdPut(id: number, stampRequestInput: StampRequestInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdPut.');
            }
            // verify required parameter 'stampRequestInput' is not null or undefined
            if (stampRequestInput === null || stampRequestInput === undefined) {
                throw new RequiredError('stampRequestInput','Required parameter stampRequestInput was null or undefined when calling stampRequestIdPut.');
            }
            const localVarPath = `/stampRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampRequestInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampRequestInput != null ? stampRequestInput : {}) : (((stampRequestInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請 差し戻し
         * @throws {RequiredError}
         */
        stampRequestIdRejectPut(id: number, stampRequestRejectInput: StampRequestRejectInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling stampRequestIdRejectPut.');
            }
            // verify required parameter 'stampRequestRejectInput' is not null or undefined
            if (stampRequestRejectInput === null || stampRequestRejectInput === undefined) {
                throw new RequiredError('stampRequestRejectInput','Required parameter stampRequestRejectInput was null or undefined when calling stampRequestIdRejectPut.');
            }
            const localVarPath = `/stampRequest/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampRequestRejectInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampRequestRejectInput != null ? stampRequestRejectInput : {}) : (((stampRequestRejectInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請を登録
         * @throws {RequiredError}
         */
        stampRequestPost(stampRequestInput: StampRequestInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'stampRequestInput' is not null or undefined
            if (stampRequestInput === null || stampRequestInput === undefined) {
                throw new RequiredError('stampRequestInput','Required parameter stampRequestInput was null or undefined when calling stampRequestPost.');
            }
            const localVarPath = `/stampRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof stampRequestInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(stampRequestInput != null ? stampRequestInput : {}) : (((stampRequestInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type StampRequestApiType = { 
    stampRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, userId?: number, options?: RequestOptions): Promise<StampRequestList>,

    stampRequestIdApprovePut(id: number, stampRequestApproveInput: StampRequestApproveInput, options?: RequestOptions): Promise<StampRequest>,

    stampRequestIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    stampRequestIdEditPut(id: number, stampRequestEditInput: StampRequestEditInput, options?: RequestOptions): Promise<StampRequest>,

    stampRequestIdGet(id: number, options?: RequestOptions): Promise<StampRequest>,

    stampRequestIdPut(id: number, stampRequestInput: StampRequestInput, options?: RequestOptions): Promise<StampRequest>,

    stampRequestIdRejectPut(id: number, stampRequestRejectInput: StampRequestRejectInput, options?: RequestOptions): Promise<StampRequest>,

    stampRequestPost(stampRequestInput: StampRequestInput, options?: RequestOptions): Promise<StampApprovalRoute>,
}

/**
 * StampRequestApi - factory function to inject configuration 
 * @export
 */
export const StampRequestApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): StampRequestApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 押捺申請一覧を取得
         * @throws {RequiredError}
         */
        stampRequestGet(page?: number, pageSize?: number, sorter?: string, filters?: string, userId?: number, options?: RequestOptions = {}): Promise<StampRequestList> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestGet(page, pageSize, sorter, filters, userId, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請 承認
         * @throws {RequiredError}
         */
        stampRequestIdApprovePut(id: number, stampRequestApproveInput: StampRequestApproveInput, options?: RequestOptions = {}): Promise<StampRequest> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdApprovePut(id, stampRequestApproveInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請削除
         * @throws {RequiredError}
         */
        stampRequestIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請 承認/差し戻し内容の修正
         * @throws {RequiredError}
         */
        stampRequestIdEditPut(id: number, stampRequestEditInput: StampRequestEditInput, options?: RequestOptions = {}): Promise<StampRequest> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdEditPut(id, stampRequestEditInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請情報を取得
         * @throws {RequiredError}
         */
        stampRequestIdGet(id: number, options?: RequestOptions = {}): Promise<StampRequest> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請 再申請/下書き更新
         * @throws {RequiredError}
         */
        stampRequestIdPut(id: number, stampRequestInput: StampRequestInput, options?: RequestOptions = {}): Promise<StampRequest> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdPut(id, stampRequestInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請 差し戻し
         * @throws {RequiredError}
         */
        stampRequestIdRejectPut(id: number, stampRequestRejectInput: StampRequestRejectInput, options?: RequestOptions = {}): Promise<StampRequest> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestIdRejectPut(id, stampRequestRejectInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請を登録
         * @throws {RequiredError}
         */
        stampRequestPost(stampRequestInput: StampRequestInput, options?: RequestOptions = {}): Promise<StampApprovalRoute> {
            const localVarFetchArgs = StampRequestApiFetchParamCreator(configuration).stampRequestPost(stampRequestInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * TemplateApi - fetch parameter creator
 * @export
 */
export const TemplateApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary テンプレート一覧を取得
         * @throws {RequiredError}
         */
        templateGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/template`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テンプレート削除
         * @throws {RequiredError}
         */
        templateIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling templateIdDelete.');
            }
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テンプレート情報からdocxファイルを作成して取得
         * @throws {RequiredError}
         */
        templateIdDocxGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling templateIdDocxGet.');
            }
            const localVarPath = `/template/{id}/docx`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テンプレート情報を取得
         * @throws {RequiredError}
         */
        templateIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling templateIdGet.');
            }
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テンプレート更新
         * @throws {RequiredError}
         */
        templateIdPut(id: number, templateInput: TemplateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling templateIdPut.');
            }
            // verify required parameter 'templateInput' is not null or undefined
            if (templateInput === null || templateInput === undefined) {
                throw new RequiredError('templateInput','Required parameter templateInput was null or undefined when calling templateIdPut.');
            }
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof templateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(templateInput != null ? templateInput : {}) : (((templateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレビューを更新
         * @throws {RequiredError}
         */
        templateIdUpdatePreviewPut(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling templateIdUpdatePreviewPut.');
            }
            const localVarPath = `/template/{id}/updatePreview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テンプレート新規作成
         * @throws {RequiredError}
         */
        templatePost(templateInput: TemplateInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'templateInput' is not null or undefined
            if (templateInput === null || templateInput === undefined) {
                throw new RequiredError('templateInput','Required parameter templateInput was null or undefined when calling templatePost.');
            }
            const localVarPath = `/template`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof templateInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(templateInput != null ? templateInput : {}) : (((templateInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレビュー
         * @throws {RequiredError}
         */
        templatePreviewPost(templatePreviewInput: TemplatePreviewInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'templatePreviewInput' is not null or undefined
            if (templatePreviewInput === null || templatePreviewInput === undefined) {
                throw new RequiredError('templatePreviewInput','Required parameter templatePreviewInput was null or undefined when calling templatePreviewPost.');
            }
            const localVarPath = `/template/preview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof templatePreviewInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(templatePreviewInput != null ? templatePreviewInput : {}) : (((templatePreviewInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type TemplateApiType = { 
    templateGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<TemplateList>,

    templateIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    templateIdDocxGet(id: number, options?: RequestOptions): Promise<TemplateDocx>,

    templateIdGet(id: number, options?: RequestOptions): Promise<Template>,

    templateIdPut(id: number, templateInput: TemplateInput, options?: RequestOptions): Promise<Template>,

    templateIdUpdatePreviewPut(id: number, options?: RequestOptions): Promise<Template>,

    templatePost(templateInput: TemplateInput, options?: RequestOptions): Promise<Template>,

    templatePreviewPost(templatePreviewInput: TemplatePreviewInput, options?: RequestOptions): Promise<TemplatePreview>,
}

/**
 * TemplateApi - factory function to inject configuration 
 * @export
 */
export const TemplateApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): TemplateApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary テンプレート一覧を取得
         * @throws {RequiredError}
         */
        templateGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<TemplateList> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary テンプレート削除
         * @throws {RequiredError}
         */
        templateIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary テンプレート情報からdocxファイルを作成して取得
         * @throws {RequiredError}
         */
        templateIdDocxGet(id: number, options?: RequestOptions = {}): Promise<TemplateDocx> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateIdDocxGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary テンプレート情報を取得
         * @throws {RequiredError}
         */
        templateIdGet(id: number, options?: RequestOptions = {}): Promise<Template> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary テンプレート更新
         * @throws {RequiredError}
         */
        templateIdPut(id: number, templateInput: TemplateInput, options?: RequestOptions = {}): Promise<Template> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateIdPut(id, templateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary プレビューを更新
         * @throws {RequiredError}
         */
        templateIdUpdatePreviewPut(id: number, options?: RequestOptions = {}): Promise<Template> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templateIdUpdatePreviewPut(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary テンプレート新規作成
         * @throws {RequiredError}
         */
        templatePost(templateInput: TemplateInput, options?: RequestOptions = {}): Promise<Template> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templatePost(templateInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary プレビュー
         * @throws {RequiredError}
         */
        templatePreviewPost(templatePreviewInput: TemplatePreviewInput, options?: RequestOptions = {}): Promise<TemplatePreview> {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).templatePreviewPost(templatePreviewInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * UnreadApi - fetch parameter creator
 * @export
 */
export const UnreadApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 契約書の未読を削除
         * @throws {RequiredError}
         */
        unreadContractIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unreadContractIdDelete.');
            }
            const localVarPath = `/unread/contract/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約書依頼の未読を削除
         * @throws {RequiredError}
         */
        unreadContractRequestIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unreadContractRequestIdDelete.');
            }
            const localVarPath = `/unread/contractRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 押捺申請の未読を削除
         * @throws {RequiredError}
         */
        unreadStampRequestIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unreadStampRequestIdDelete.');
            }
            const localVarPath = `/unread/stampRequest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type UnreadApiType = { 
    unreadContractIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    unreadContractRequestIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    unreadStampRequestIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,
}

/**
 * UnreadApi - factory function to inject configuration 
 * @export
 */
export const UnreadApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): UnreadApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 契約書の未読を削除
         * @throws {RequiredError}
         */
        unreadContractIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = UnreadApiFetchParamCreator(configuration).unreadContractIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 契約書依頼の未読を削除
         * @throws {RequiredError}
         */
        unreadContractRequestIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = UnreadApiFetchParamCreator(configuration).unreadContractRequestIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 押捺申請の未読を削除
         * @throws {RequiredError}
         */
        unreadStampRequestIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = UnreadApiFetchParamCreator(configuration).unreadStampRequestIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ログイン中のユーザーのメールアドレスをCognitoに登録されている値に更新
         * @throws {RequiredError}
         */
        userCurrentEmailPost(options: RequestOptions): FetchArgs {
            const localVarPath = `/user/current/email`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザー情報を取得
         * @throws {RequiredError}
         */
        userCurrentGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/user/current`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザーの2段階認証の設定を取得
         * @throws {RequiredError}
         */
        userCurrentMfaGet(options: RequestOptions): FetchArgs {
            const localVarPath = `/user/current/mfa`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザーの名前を更新
         * @throws {RequiredError}
         */
        userCurrentNamePost(inputUserName: InputUserName, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputUserName' is not null or undefined
            if (inputUserName === null || inputUserName === undefined) {
                throw new RequiredError('inputUserName','Required parameter inputUserName was null or undefined when calling userCurrentNamePost.');
            }
            const localVarPath = `/user/current/name`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputUserName !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputUserName != null ? inputUserName : {}) : (((inputUserName:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワードリセット
         * @throws {RequiredError}
         */
        userForgotPasswordPost(inputForgotPassword: InputForgotPassword, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputForgotPassword' is not null or undefined
            if (inputForgotPassword === null || inputForgotPassword === undefined) {
                throw new RequiredError('inputForgotPassword','Required parameter inputForgotPassword was null or undefined when calling userForgotPasswordPost.');
            }
            const localVarPath = `/user/forgotPassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputForgotPassword !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputForgotPassword != null ? inputForgotPassword : {}) : (((inputForgotPassword:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー一覧を取得
         * @throws {RequiredError}
         */
        userGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー削除
         * @throws {RequiredError}
         */
        userIdDelete(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userIdDelete.');
            }
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー情報を取得
         * @throws {RequiredError}
         */
        userIdGet(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userIdGet.');
            }
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー編集
         * @throws {RequiredError}
         */
        userIdPut(id: number, inputUser: InputUser, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userIdPut.');
            }
            // verify required parameter 'inputUser' is not null or undefined
            if (inputUser === null || inputUser === undefined) {
                throw new RequiredError('inputUser','Required parameter inputUser was null or undefined when calling userIdPut.');
            }
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputUser != null ? inputUser : {}) : (((inputUser:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 初期パスワードを再送する
         * @throws {RequiredError}
         */
        userIdResendPasswordPut(id: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userIdResendPasswordPut.');
            }
            const localVarPath = `/user/{id}/resendPassword`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メールアドレスが登録済みの場合の通知メールを送信
         * @throws {RequiredError}
         */
        userNotifyExistsPost(inputNotifyExists: InputNotifyExists, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputNotifyExists' is not null or undefined
            if (inputNotifyExists === null || inputNotifyExists === undefined) {
                throw new RequiredError('inputNotifyExists','Required parameter inputNotifyExists was null or undefined when calling userNotifyExistsPost.');
            }
            const localVarPath = `/user/notifyExists`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputNotifyExists !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputNotifyExists != null ? inputNotifyExists : {}) : (((inputNotifyExists:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー登録
         * @throws {RequiredError}
         */
        userPost(inputUser: InputUser, options: RequestOptions): FetchArgs {
            // verify required parameter 'inputUser' is not null or undefined
            if (inputUser === null || inputUser === undefined) {
                throw new RequiredError('inputUser','Required parameter inputUser was null or undefined when calling userPost.');
            }
            const localVarPath = `/user`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof inputUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inputUser != null ? inputUser : {}) : (((inputUser:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type UserApiType = { 
    userCurrentEmailPost(options?: RequestOptions): Promise<User>,

    userCurrentGet(options?: RequestOptions): Promise<User>,

    userCurrentMfaGet(options?: RequestOptions): Promise<UserMfa>,

    userCurrentNamePost(inputUserName: InputUserName, options?: RequestOptions): Promise<Object>,

    userForgotPasswordPost(inputForgotPassword: InputForgotPassword, options?: RequestOptions): Promise<Object>,

    userGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<UserList>,

    userIdDelete(id: number, options?: RequestOptions): Promise<DeleteResult>,

    userIdGet(id: number, options?: RequestOptions): Promise<User>,

    userIdPut(id: number, inputUser: InputUser, options?: RequestOptions): Promise<User>,

    userIdResendPasswordPut(id: number, options?: RequestOptions): Promise<User>,

    userNotifyExistsPost(inputNotifyExists: InputNotifyExists, options?: RequestOptions): Promise<Object>,

    userPost(inputUser: InputUser, options?: RequestOptions): Promise<User>,
}

/**
 * UserApi - factory function to inject configuration 
 * @export
 */
export const UserApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): UserApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary ログイン中のユーザーのメールアドレスをCognitoに登録されている値に更新
         * @throws {RequiredError}
         */
        userCurrentEmailPost(options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userCurrentEmailPost(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ログイン中のユーザー情報を取得
         * @throws {RequiredError}
         */
        userCurrentGet(options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userCurrentGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ログイン中のユーザーの2段階認証の設定を取得
         * @throws {RequiredError}
         */
        userCurrentMfaGet(options?: RequestOptions = {}): Promise<UserMfa> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userCurrentMfaGet(options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ログイン中のユーザーの名前を更新
         * @throws {RequiredError}
         */
        userCurrentNamePost(inputUserName: InputUserName, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userCurrentNamePost(inputUserName, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary パスワードリセット
         * @throws {RequiredError}
         */
        userForgotPasswordPost(inputForgotPassword: InputForgotPassword, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userForgotPasswordPost(inputForgotPassword, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ユーザー一覧を取得
         * @throws {RequiredError}
         */
        userGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<UserList> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ユーザー削除
         * @throws {RequiredError}
         */
        userIdDelete(id: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userIdDelete(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ユーザー情報を取得
         * @throws {RequiredError}
         */
        userIdGet(id: number, options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userIdGet(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ユーザー編集
         * @throws {RequiredError}
         */
        userIdPut(id: number, inputUser: InputUser, options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userIdPut(id, inputUser, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 初期パスワードを再送する
         * @throws {RequiredError}
         */
        userIdResendPasswordPut(id: number, options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userIdResendPasswordPut(id, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary メールアドレスが登録済みの場合の通知メールを送信
         * @throws {RequiredError}
         */
        userNotifyExistsPost(inputNotifyExists: InputNotifyExists, options?: RequestOptions = {}): Promise<Object> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userNotifyExistsPost(inputNotifyExists, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary ユーザー登録
         * @throws {RequiredError}
         */
        userPost(inputUser: InputUser, options?: RequestOptions = {}): Promise<User> {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).userPost(inputUser, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


/**
 * VariableApi - fetch parameter creator
 * @export
 */
export const VariableApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 共通変数を削除
         * @throws {RequiredError}
         */
        variableCommonIdDelete(commonId: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'commonId' is not null or undefined
            if (commonId === null || commonId === undefined) {
                throw new RequiredError('commonId','Required parameter commonId was null or undefined when calling variableCommonIdDelete.');
            }
            const localVarPath = `/variable/{commonId}`
                .replace(`{${"commonId"}}`, encodeURIComponent(String(commonId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 変数情報を取得
         * @throws {RequiredError}
         */
        variableCommonIdGet(commonId: number, options: RequestOptions): FetchArgs {
            // verify required parameter 'commonId' is not null or undefined
            if (commonId === null || commonId === undefined) {
                throw new RequiredError('commonId','Required parameter commonId was null or undefined when calling variableCommonIdGet.');
            }
            const localVarPath = `/variable/{commonId}`
                .replace(`{${"commonId"}}`, encodeURIComponent(String(commonId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通変数を更新
         * @throws {RequiredError}
         */
        variableCommonIdPut(commonId: number, variableInput: VariableInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'commonId' is not null or undefined
            if (commonId === null || commonId === undefined) {
                throw new RequiredError('commonId','Required parameter commonId was null or undefined when calling variableCommonIdPut.');
            }
            // verify required parameter 'variableInput' is not null or undefined
            if (variableInput === null || variableInput === undefined) {
                throw new RequiredError('variableInput','Required parameter variableInput was null or undefined when calling variableCommonIdPut.');
            }
            const localVarPath = `/variable/{commonId}`
                .replace(`{${"commonId"}}`, encodeURIComponent(String(commonId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'PUT' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof variableInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(variableInput != null ? variableInput : {}) : (((variableInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通変数一覧を取得
         * @throws {RequiredError}
         */
        variableGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options: RequestOptions): FetchArgs {
            const localVarPath = `/variable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = ((page:any):string);
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = ((pageSize:any):string);
            }

            if (sorter !== undefined) {
                localVarQueryParameter['sorter'] = ((sorter:any):string);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = ((filters:any):string);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 共通変数を作成
         * @throws {RequiredError}
         */
        variablePost(variableInput: VariableInput, options: RequestOptions): FetchArgs {
            // verify required parameter 'variableInput' is not null or undefined
            if (variableInput === null || variableInput === undefined) {
                throw new RequiredError('variableInput','Required parameter variableInput was null or undefined when calling variablePost.');
            }
            const localVarPath = `/variable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions: RequestOptions = Object.assign({}, { method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (typeof variableInput !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(variableInput != null ? variableInput : {}) : (((variableInput:any):string) || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

export type VariableApiType = { 
    variableCommonIdDelete(commonId: number, options?: RequestOptions): Promise<DeleteResult>,

    variableCommonIdGet(commonId: number, options?: RequestOptions): Promise<Variable>,

    variableCommonIdPut(commonId: number, variableInput: VariableInput, options?: RequestOptions): Promise<Variable>,

    variableGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions): Promise<VariableList>,

    variablePost(variableInput: VariableInput, options?: RequestOptions): Promise<Variable>,
}

/**
 * VariableApi - factory function to inject configuration 
 * @export
 */
export const VariableApi = function(configuration?: Configuration, fetch: FetchAPI = portableFetch): VariableApiType {
    const basePath: string = (configuration && configuration.basePath) || BASE_PATH;
    return {
        /**
         * 
         * @summary 共通変数を削除
         * @throws {RequiredError}
         */
        variableCommonIdDelete(commonId: number, options?: RequestOptions = {}): Promise<DeleteResult> {
            const localVarFetchArgs = VariableApiFetchParamCreator(configuration).variableCommonIdDelete(commonId, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 変数情報を取得
         * @throws {RequiredError}
         */
        variableCommonIdGet(commonId: number, options?: RequestOptions = {}): Promise<Variable> {
            const localVarFetchArgs = VariableApiFetchParamCreator(configuration).variableCommonIdGet(commonId, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通変数を更新
         * @throws {RequiredError}
         */
        variableCommonIdPut(commonId: number, variableInput: VariableInput, options?: RequestOptions = {}): Promise<Variable> {
            const localVarFetchArgs = VariableApiFetchParamCreator(configuration).variableCommonIdPut(commonId, variableInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通変数一覧を取得
         * @throws {RequiredError}
         */
        variableGet(page?: number, pageSize?: number, sorter?: string, filters?: string, options?: RequestOptions = {}): Promise<VariableList> {
            const localVarFetchArgs = VariableApiFetchParamCreator(configuration).variableGet(page, pageSize, sorter, filters, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
        /**
         * 
         * @summary 共通変数を作成
         * @throws {RequiredError}
         */
        variablePost(variableInput: VariableInput, options?: RequestOptions = {}): Promise<Variable> {
            const localVarFetchArgs = VariableApiFetchParamCreator(configuration).variablePost(variableInput, options);
            return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    throw response;
                }
            });
        },
    }
};


export type ApiTypes = { 
    AIApi: AIApiType,

    AccountApi: AccountApiType,

    ArchiveApi: ArchiveApiType,

    CommonClauseApi: CommonClauseApiType,

    ConfigApi: ConfigApiType,

    ContractApi: ContractApiType,

    ContractFormItemApi: ContractFormItemApiType,

    ContractNotificationApi: ContractNotificationApiType,

    ContractRequestApi: ContractRequestApiType,

    CorporationApi: CorporationApiType,

    FileApi: FileApiType,

    GroupApi: GroupApiType,

    IPApi: IPApiType,

    NotificationApi: NotificationApiType,

    OperationLogApi: OperationLogApiType,

    RoleApi: RoleApiType,

    SignupApi: SignupApiType,

    StampApprovalRouteApi: StampApprovalRouteApiType,

    StampRequestApi: StampRequestApiType,

    TemplateApi: TemplateApiType,

    UnreadApi: UnreadApiType,

    UserApi: UserApiType,

    VariableApi: VariableApiType,
 }
